// cache-bust 2026-10-05 bundles v2
// cache-bust 2026-08-21 fix image press bundle
/* bundle-intel cache-bust 2026-06-17 currency-localize v3 */
(function() {
  // IIFE-scoped currency helper (used across all builders below)
  var FP_ACTIVE_CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fpAmt(n) { var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; var s = String(fpCurSym || '').trim(); return /^(EUR|CHF|DKK|SEK|NOK|PLN|HUF|RON|CZK|BGN)$/.test(c) ? n + ' ' + s : (fpCurSym + n); }
  var FP_CUR_SYM = {USD:'$',CAD:'CA$',AUD:'A$',NZD:'NZ$',GBP:'£',EUR:'€',CHF:'CHF ',SEK:'kr',NOK:'kr',DKK:'kr',PLN:'zł',CZK:'Kč',HUF:'Ft',RON:'lei',BGN:'лв',TRY:'₺',JPY:'¥',CNY:'¥',KRW:'₩',INR:'₹',BRL:'R$',MXN:'MX$',ZAR:'R'};
  var fpCurSym = FP_CUR_SYM[FP_ACTIVE_CUR] || '$';

  function fmtMoney(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var noDec = ['JPY','HUF','KRW'].includes(cur);
    var v = noDec ? String(Math.round(cents/100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : (cents/100).toFixed(2);
    var sym = {USD:'$',EUR:'€',GBP:'£',CAD:'CA$',AUD:'A$',NZD:'NZ$',CHF:'CHF ',JPY:'¥',MXN:'MX$',DKK:'kr',SEK:'kr',NOK:'kr',PLN:'zł',HUF:'Ft',RON:'lei',CZK:'Kč',BGN:'лв'}[cur] || '$';
    if (cur === 'EUR' || cur === 'CHF' || ['DKK','SEK','NOK','PLN','HUF','RON','CZK','BGN'].includes(cur)) return (cur === 'CHF' ? v : v.replace('.', ',')) + ' ' + sym.trim();
    return sym + v;
  }

  function getProductCollections() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product && meta.product.type) return meta.product.type;
    return '';
  }

  function buildEyebrow() {
    var col = getProductCollections() || 'French Press & Co';
    return '<span class="fp-pdp-eyebrow" data-fp-pdp-eyebrow>' + col + '</span>';
  }

  function escapeHTML(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function buildBreadcrumb() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var p = meta && meta.product;
    var type = (p && p.type) || '';
    var titleEl = document.querySelector('.product-information h1');
    var title = (titleEl && titleEl.textContent.trim()) || (p && p.variants && p.variants[0] && (p.variants[0].name || '').split(' - ')[0]) || '';
    var typeSlug = type.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    var typeLink = typeSlug ? (window.Shopify.routes.root + 'collections/') + typeSlug : (window.Shopify.routes.root + 'collections/all');
    var sep = '<span class="fp-pdp-bc__sep" aria-hidden="true">/</span>';
    var html = '<nav class="fp-pdp-bc" data-fp-pdp-bc aria-label="Breadcrumb">'
      + '<a href="/">Home</a>' + sep;
    if (type) html += '<a href="' + typeLink + '">' + escapeHTML(type) + '</a>' + sep;
    html += '<span class="fp-pdp-bc__current" aria-current="page">' + escapeHTML(title || 'Product') + '</span>'
      + '</nav>';
    return html;
  }

  function buildSubtitle() {
    return '<p class="fp-pdp-subtitle" data-fp-pdp-subtitle><span>Stainless steel</span><span class="fp-dot">·</span><span>Double-walled insulation</span><span class="fp-dot">·</span><span>1-year guarantee</span></p>';
  }

  function buildKlarna() {
    var price = 0;
    // Priority 1: read current visible price from the DOM (always reflects selected variant)
    var pEl = document.querySelector('.product-information .price__regular .price-item--regular') || document.querySelector('.product-information .price__regular .price-item') || document.querySelector('.product-information .price__regular');
    if (pEl) {
      var m = pEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
      var f = parseFloat(m);
      if (!isNaN(f)) price = Math.round(f * 100);
    }
    // Fallback: variants array
    if (!price) {
      var product = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      var sel = new URLSearchParams(location.search).get('variant') || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId);
      if (product && product.variants) {
        var v = product.variants.find(function(x){ return x.id == sel; }) || product.variants[0];
        if (v) price = v.price;
      }
    }
    /* amt-bnpl-1610 : ligne par pays (snippets/amt-bnpl.liquid) ; avant « 4 interest-free payments » Klarna pour tous, y compris US où Klarna n'existe pas au paiement */
    return '<div class="fp-pdp-klarna-wrap" data-fp-pdp-klarna>' + (window.amtBnplHtml ? window.amtBnplHtml(price) : '') + '</div>';
  }

  // Delivery estimate under the Klarna line, as a DATE range (Baymard: dates beat "business days").
  // DISABLED: a displayed date is a promise. Turn on once the ranges below are confirmed and the
  // shipping policy page says the same thing. Ranges are calendar days, order to door.
  var FP_DELIVERY = {
    enabled: false,
    ranges: { US: [7, 14], CA: [7, 12], GB: [6, 12], EU: [6, 12], AU: [8, 15], NZ: [8, 15], other: [10, 20] },
    eu: 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE NO CH'.split(' ')
  };
  function buildDelivery() {
    try {
      if (!FP_DELIVERY.enabled) return '';
      var cc = (window.Shopify && Shopify.country) || 'US';
      var r = FP_DELIVERY.ranges[cc] || (FP_DELIVERY.eu.indexOf(cc) > -1 ? FP_DELIVERY.ranges.EU : FP_DELIVERY.ranges.other);
      var fmt = new Intl.DateTimeFormat(navigator.language || 'en-US', { month: 'short', day: 'numeric' });
      var d = function(n){ var x = new Date(); x.setDate(x.getDate() + n); return fmt.format(x); };
      return '<p class="fp-pdp-delivery" data-fp-pdp-delivery>Estimated delivery <strong class="notranslate" translate="no">' + d(r[0]) + ' – ' + d(r[1]) + '</strong></p>';
    } catch (e) { return ''; }
  }

  // 2026-09-30 (Mathéo) : delivery = order date + 6 to 10 CALENDAR days (weekends included, no cut-off time),
  // processing within 24h on business days. 05/10/26 : shipping policy, FAQ, contact and shipping pages say the same.
  var FP_TRUST_ETA = { processingHours: 24, minDays: 6, maxDays: 10 };
  function fpAddBusinessDays(n) {
    var x = new Date();
    while (n > 0) { x.setDate(x.getDate() + 1); var wd = x.getDay(); if (wd !== 0 && wd !== 6) n--; }
    return x;
  }
  function fpEtaDate() {
    try {
      var lang = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en-US';
      var fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric' });
      var add = function(n){ var x = new Date(); x.setDate(x.getDate() + n); while (x.getDay() === 0 || x.getDay() === 6) x.setDate(x.getDate() + 1); return x; }; // 05/10/26 jamais un week-end (fp-express-checkout-2026-10-05)
      // 30/09/26 (Mathéo) : commande + 6 à 10 jours calendaires, comme Atlas et le tiroir
      return fmt.format(add(FP_TRUST_ETA.minDays)) + ' – ' + fmt.format(add(FP_TRUST_ETA.maxDays));
    } catch (e) { return ''; }
  }

  function buildTrust() {
    var ICON = {
      community: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 28S4 20 4 12.5C4 8.5 7 5 11 5c2.5 0 4.5 1.5 5 3.5C16.5 6.5 18.5 5 21 5c4 0 7 3.5 7 7.5C28 20 16 28 16 28Z"/><path d="M13 13c0 2 1.3 3.5 3 3.5s3-1.5 3-3.5"/><circle cx="16" cy="11" r="0.8" fill="currentColor"/></svg>',
      expert: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="14" r="7"/><path d="M12.5 14l2.5 2.5 4.5-4.5"/><path d="M11 20l-2 8 5-2.5 2 4.5 2-4.5 5 2.5-2-8"/></svg>',
      cafe: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 14h17v8a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-8z"/><path d="M23 16h3a3 3 0 0 1 0 6h-3"/><path d="M10 9c-1-1.5-1-3 0-4.5M14.5 9c-1-1.5-1-3 0-4.5M19 9c-1-1.5-1-3 0-4.5"/></svg>',
      guarantee: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
      clock: '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="16" r="12"/><polyline points="16 9 16 16 21 19"/></svg>',
      processing: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      eta: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>',
      returns: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>'
    };
    // 2026-09-18: the "Ships today / order within" countdown card was removed. The timer was a
    // rolling 6h cycle, not a real dispatch cutoff, so it read as fake urgency. Replaced by a
    // claim the shipping accordion already makes (tracked, free over the FP_FREE_SHIP threshold).
    // Three cards, not four: "Loved by 10K+" repeated the rating + review count
    // already sitting a few pixels above, and four cards side by side left each
    // one too narrow to read. Design feedback 2026-09-03.
    // 30/09/26 (Mathéo) : la date de livraison mise en valeur, pleine largeur au-dessus des cartes (comme Atlas)
    return '<div class="fp-pdp-eta" data-fp-pdp-eta>' + ICON.truck + '<span class="fp-pdp-eta__text"><span class="fp-pdp-eta__label">Dispatched within</span><strong data-fp-eta-ships>24 hours</strong><span class="fp-pdp-eta__label">on business days</span></span></div>'
      + '<div class="fp-pdp-trust fp-pdp-trust--two" data-fp-pdp-trust>'
      + '<div class="fp-pdp-trust__item fp-pdp-trust__item--shipping">' + ICON.truck + '<span class="fp-pdp-trust__label">Tracked shipping</span><span class="fp-pdp-trust__sub">Free on orders over&nbsp;<span class="notranslate" translate="no">' + fpMoneyShort(fpFreeShipCents()) + '</span></span></div>'
      + '<div class="fp-pdp-trust__item fp-pdp-trust__item--processing">' + ICON.processing + '<span class="fp-pdp-trust__label">Processed in ' + FP_TRUST_ETA.processingHours + 'h</span><span class="fp-pdp-trust__sub">On business days</span></div>'
      + '</div>';
  }

  
  function fpFormatMoney(cents) { return fmtMoney(cents); }

  // ===========================================================================
  //  CATEGORY ENGINE v2 — tag-driven, deterministic
  //  Built from a real audit of the FP catalog (104 products, see audit script)
  //  Tags are the most reliable signal (set explicitly in Shopify admin).
  //  product_type is fragmented, title regex is too fragile alone.
  // ===========================================================================
  function fpCategoryOf(prod) {
    var tagsRaw = prod && prod.tags;
    var tags = [];
    if (Array.isArray(tagsRaw)) tags = tagsRaw;
    else if (typeof tagsRaw === 'string') tags = tagsRaw.split(/\s*,\s*/);
    var T = tags.map(function(t){ return String(t || '').toLowerCase().trim(); });
    var has = function(t) { return T.indexOf(t) !== -1; };
    var typeL = String((prod && prod.product_type) || '').toLowerCase().trim();
    var titleL = String((prod && prod.title) || '').toLowerCase();

    // 1) Bundles/sets — special category. Tag-driven only (avoid false positives like "Pour-Over Set" which is a single pour-over maker).
    if (has('gift box')) return 'gift-set';

    // 2) Tag-driven (most reliable)
    if (has('grinders') || has('grinder')) return 'grinder';
    if (has('cleaning kit') || /care kit|cleaning|barista care/.test(titleL)) return 'care';
    if (has('scales') || /scale\b/.test(titleL)) return 'scale';
    if (has('milk frother') || /frother|whisk\b/.test(titleL)) return 'frother';
    if (has('storage') || /canister|cellar|bean (display|storage)/.test(titleL)) return 'storage';
    if (has('spoons') || /scoop|spoon|tamper/.test(titleL)) return 'spoon';

    // 3) Brewing methods (tag 'maker' is generic — needs disambiguation)
    if (has('french press') || /french press|cafetière|cafetiere|press mug/.test(titleL)) return 'french-press';
    if (has('moka') || /moka|stovetop|bialetti/.test(titleL)) return 'moka';
    // Cold brew BEFORE pour-over (a "cold drip tower" must not be classified as pour-over)
    if (/cold (brew|drip)|cold-?drip|cold-?brew|drip tower/.test(titleL)) return 'cold-brew';
    if (has('over') || /pour[- ]over|chemex|v60/.test(titleL)) return 'pour-over';
    if (/aeropress/.test(titleL)) return 'aeropress';
    if (has('manual') && has('espresso')) return 'manual-espresso';
    if (has('espresso') && has('maker')) return 'espresso-machine';

    // 4) Kettles (tea kettle vs brewing kettle)
    if (has('kettles') || has('kettle') || /kettle|bouilloire|teapot/.test(titleL)) {
      if (has('tea') || /tea/.test(titleL)) return 'tea';
      return 'kettle';
    }

    // 5) Drinkware (3 flavors — espresso vs coffee vs travel)
    if (has('espresso glass') || /espresso (cup|glass)|demitasse|cortado|tasting glass|espresso cup/.test(titleL)) return 'espresso-cup';
    if (has('coffee glass') || /tasting mug|fluted/.test(titleL)) return 'coffee-cup';
    if (has('mug') || /mug|tumbler|flask/.test(titleL)) return 'mug';
    if (has('drinkware')) return 'mug';

    // 6) product_type fallback
    if (/grinder|burr|mill/.test(typeL)) return 'grinder';
    if (/kettle/.test(typeL)) return /tea/.test(typeL) ? 'tea' : 'kettle';
    if (/frother|whisk/.test(typeL)) return 'frother';
    if (/scale/.test(typeL)) return 'scale';
    if (/storage|canister/.test(typeL)) return 'storage';
    if (/spoon|scoop/.test(typeL)) return 'spoon';
    if (/cleaning|care/.test(typeL)) return 'care';
    if (/french press/.test(typeL)) return 'french-press';
    if (/cafetière|cafetiere|pour|over/.test(typeL)) return 'pour-over';
    if (/moka/.test(typeL)) return 'moka';
    if (/cold/.test(typeL)) return 'cold-brew';
    if (/espresso/.test(typeL)) return 'espresso-machine';
    if (/espresso (cup|glass)/.test(typeL)) return 'espresso-cup';
    if (/coffee glass/.test(typeL)) return 'coffee-cup';
    if (/mug|cup|drinkware|glass|tumbler/.test(typeL)) return 'mug';
    if (/gift|set|kit/.test(typeL)) return 'gift-set';

    return 'other';
  }

  // CATEGORY COMPLEMENTARITY MAP — coffee logic (curated from forums + Polène-style cross-sell)
  // Each entry: priority-ordered list of categories that genuinely complete the ritual.
  // NEVER includes the source category (no competing items).
  var FP_COMPLEMENTS = {
    // brewers -> grinder + (kettle/scale) + finishing roles. Grinder always first available.
    'french-press':     ['grinder','kettle','scale','spoon','storage','mug','coffee-cup','care'],
    'pour-over':        ['grinder','kettle','scale','spoon','storage','mug','coffee-cup','care'],
    'aeropress':        ['grinder','kettle','scale','spoon','mug','care'],
    'moka':             ['grinder','frother','espresso-cup','mug','spoon','care','storage'],
    'espresso-machine': ['grinder','frother','espresso-cup','scale','spoon','care'],
    'manual-espresso':  ['grinder','scale','espresso-cup','frother','spoon','care'],
    'cold-brew':        ['grinder','scale','storage','spoon','mug','coffee-cup'],
    // grinder -> non-brewer roles FIRST so it never picks two brewers.
    'grinder':          ['kettle','scale','storage','spoon','french-press','pour-over','moka','frother','mug','coffee-cup'],
    // kettle -> a brewer to use it with + grinder.
    'kettle':           ['grinder','french-press','pour-over','scale','spoon','mug','coffee-cup','storage'],
    // tea/kettle -> grinder + un vrai brewer pour infuser (jamais 2 bouilloires).
    'tea':              ['grinder','french-press','pour-over','scale','spoon','storage','mug'],
    'scale':            ['grinder','kettle','french-press','pour-over','spoon','storage','mug'],
    'frother':          ['grinder','moka','espresso-cup','mug','coffee-cup','spoon','storage'],
    'mug':              ['grinder','french-press','pour-over','kettle','spoon','storage','scale'],
    'coffee-cup':       ['grinder','french-press','pour-over','kettle','spoon','storage','scale'],
    'espresso-cup':     ['grinder','moka','frother','espresso-machine','spoon','storage'],
    'storage':          ['grinder','scale','spoon','kettle','french-press','pour-over','mug'],
    'spoon':            ['grinder','french-press','pour-over','kettle','scale','storage','mug'],
    'care':             ['grinder','french-press','pour-over','kettle','scale','spoon'],
    'gift-set':         ['grinder','scale','spoon','storage','kettle','mug','coffee-cup'],
    'other':            ['grinder','kettle','french-press','pour-over','scale','spoon','storage','mug']
  };

  // Fetched-once catalog cache (~75KB)
  var fpCatalogPromise = null;
  // fp-bundles.json stocke les composants avec leur handle PAR DEFAUT et leur id.
  // Sur un marche traduit, seul l'id est stable : on retrouve le handle localise via le catalogue.
  async function fpResolveHandle(id, fallbackHandle) {
    try {
      var cat = await fpFetchCatalog();
      var s = String(id);
      for (var i = 0; i < cat.length; i++) {
        if (String(cat[i].id) === s) return cat[i].handle;
        if (cat[i].handle === fallbackHandle) return cat[i].handle;
      }
    } catch (e) {}
    return fallbackHandle;
  }
  function fpFetchCatalog() {
    if (fpCatalogPromise) return fpCatalogPromise;
    // Racine localisee obligatoire : les handles sont traduits par marche, un handle par
    // defaut renvoie 404 sous /fr-fr/ et casse tout le bundle qui le contient.
    var _catRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fpCatalogPromise = fetch(_catRoot + 'products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(d){ return (d && d.products) || []; })
      .catch(function(){ return []; });
    return fpCatalogPromise;
  }

  // ===== Bundle Intelligence (alimenté par n8n via 2 assets) =====
  // Gate preview : tant que false, le live est strictement inchangé. ?preview_ritual=1 force l'aperçu.
  var RITUAL_ON = /[?&]preview_ritual=1/.test(location.search) || true; /* RITUAL_LIVE */
  // ===== VENTES GROUPÉES V2 (05/10/26, fp-bundle-2026-10-05) =====
  // Brew Kit : bundle natif presse Signature + moulin Precision, prix fixe par marché (listes de prix recalculées chaque lundi).
  // Morning Ritual : bundle natif à 3 pièces, -savePct % par remise automatique.
  // Prix affichés = prix facturés, au centime. « separately » = vraie somme des prix actuels des pièces dans la devise du visiteur.
  var FP_KIT = { id: '11244725797207', handle: 'the-brew-kit', press: '10202943848791', grinder: '10203729527127' };
  var FP_FREE_SHIP = { USD: 7500, EUR: 6500, GBP: 5500, CAD: 9900, AUD: 9900, NZD: 12900, CHF: 6000, MXN: 134900, DKK: 49900, SEK: 74900, NOK: 69900, PLN: 28900, HUF: 2400000, RON: 34900, CZK: 160000, BGN: 12800, JPY: 1200000 };
  function fpFreeShipCents() { var c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'; return FP_FREE_SHIP[c] || 7500; }
  function fpShipLine(payCents) { return payCents >= fpFreeShipCents() ? 'Free tracked shipping &middot; 30-day returns' : 'Free tracked shipping over ' + fpMoneyShort(fpFreeShipCents()) + ' &middot; 30-day returns'; }
  // « $189.00 » -> « $189 » (montants ronds seulement ; sinon au centime)
  function fpMoneyShort(cents) { var t = fpFormatMoney(cents); return (cents % 100 === 0) ? t.replace(/([.,])00(?!\d)/, '') : t; }
  function _fpNrm(s) { return String(s == null ? '' : s).replace(/[\u00a0\u202f]/g, ' ').trim(); }
  function fpImg(p) { var s = (p && (p.featured_image || (p.images && p.images[0]))) || ''; if (s && typeof s === 'object') s = s.src || s.url || ''; s = s ? (s.indexOf('//') === 0 ? 'https:' + s : s) : ''; return s ? s + (s.indexOf('?') >= 0 ? '&' : '?') + 'width=180' : ''; }
  // valeurs d'une option (product.js) ; correspondance bundle <-> pièces par POSITION (libellés différents selon le marché)
  function _fpOptVals(prod, pos) { var o = ((prod && prod.options) || [])[pos]; return (o && (o.values || [])) || []; }
  function _fpIdxOf(prod, pos, val) { var vs = _fpOptVals(prod, pos), n = _fpNrm(val); for (var i = 0; i < vs.length; i++) if (_fpNrm(vs[i]) === n) return i; return -1; }
  var _fpBundleCache = {};
  // bundle natif + ses pièces (option n du bundle = option unique de la pièce n), prix dans la devise du visiteur
  async function fpLoadBundle(id, handle, comps, pct) {
    if (_fpBundleCache[id]) return _fpBundleCache[id];
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var hs = await Promise.all([fpResolveHandle(id, handle)].concat((comps || []).map(function (c) { return fpResolveHandle(c.id, c.handle); })));
    var d = await Promise.all(hs.map(function (h) { return _fpLoadProduct(root, h); }));
    if (d.some(function (x) { return !x; }) || d.length < 2) return null;
    var K = { kit: d[0], comps: d.slice(1), handles: hs, pct: pct || 0 };
    K.press = K.comps[0]; K.grinder = K.comps[1];
    return (_fpBundleCache[id] = K);
  }
  // idxs[n] = position de la valeur choisie pour l'option n du bundle
  function fpBundlePrices(K, idxs) {
    if (!K || !K.kit || !idxs || idxs.some(function (i) { return i < 0; })) return null;
    var kvals = idxs.map(function (ix, o) { return _fpOptVals(K.kit, o)[ix]; });
    var kv = (K.kit.variants || []).filter(function (v) { return kvals.every(function (val, o) { return v['option' + (o + 1)] === val; }); })[0];
    if (!kv) return null;
    var sep = 0;
    for (var o = 0; o < K.comps.length; o++) {
      var cval = _fpOptVals(K.comps[o], 0)[idxs[o]];
      var cv = (K.comps[o].variants || []).filter(function (v) { return v.option1 === cval; })[0] || (K.comps[o].variants.length === 1 ? K.comps[o].variants[0] : null);
      if (!cv) return null; sep += cv.price;
    }
    var pay = kv.price - Math.round(kv.price * (K.pct || 0) / 100);
    return { kit: pay, sep: sep, save: sep - pay, variant: kv };
  }
  function fpKitPrices(K, si, ci) { return fpBundlePrices(K, [si, ci]); }
  // la moins chère des variantes disponibles (pour « From »)
  function fpBundleBest(K) {
    var best = null;
    (K.kit.variants || []).forEach(function (v) {
      var n = (K.kit.options || []).length, idxs = [];
      for (var o = 0; o < n; o++) idxs.push(_fpIdxOf(K.kit, o, v['option' + (o + 1)]));
      var P = fpBundlePrices(K, idxs);
      if (P && (!best || (v.available && !best.variant.available) || (v.available === best.variant.available && P.kit < best.kit))) best = P;
    });
    return best;
  }
  async function fpLoadKit() {
    return fpLoadBundle(FP_KIT.id, FP_KIT.handle, [{ id: FP_KIT.press, handle: 'french-press-coffee-maker' }, { id: FP_KIT.grinder, handle: 'manual-coffee-grinder' }], 0);
  }
  var _fpKitData = null;
  // taille / couleur choisies sur la fiche (positions), sinon les premières
  function fpKitSelection(K, curId) {
    var si = 0, ci = 0;
    var input = document.querySelector('.product-information form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vid = input && String(input.value);
    if (vid) {
      if (curId === FP_KIT.press) { var pv = (K.press.variants || []).filter(function (v) { return String(v.id) === vid; })[0]; if (pv) si = Math.max(0, _fpIdxOf(K.press, 0, pv.option1)); }
      if (curId === FP_KIT.grinder) { var gv = (K.grinder.variants || []).filter(function (v) { return String(v.id) === vid; })[0]; if (gv) ci = Math.max(0, _fpIdxOf(K.grinder, 0, gv.option1)); }
    }
    return { si: si, ci: ci };
  }
  // carte commune à tous les blocs (même structure, même bouton secondaire)
  function fpCardHTML(o) {
    var th = o.thumbs.map(function (t) { return '<a href="' + t.href + '" class="fp-pdp-ritual__thumb" title="' + escapeHTML(t.alt) + '"><img src="' + t.src + '" alt="' + escapeHTML(t.alt) + '" loading="lazy" width="54" height="66"></a>'; }).join('<span class="fp-pdp-ritual__plus">+</span>');
    return '<div class="fp-pdp-ritual fp-pdp-kit' + (o.thumbs.length > 2 ? ' fp-pdp-kit--3' : '') + '" data-fp-ritual data-amt-zone="bundle" ' + o.attrs + ' data-fp-eyebrow="' + escapeHTML(o.eyebrow) + '" data-fp-title="' + escapeHTML(o.title) + '">'
      + '<div class="fp-pdp-ritual__thumbs">' + th + '</div>'
      + '<div class="fp-pdp-ritual__info">'
      +   '<span class="fp-pdp-ritual__name">' + escapeHTML(o.name) + '</span>'
      +   (o.sub ? '<span class="fp-pdp-kit__sub">' + escapeHTML(o.sub) + '</span>' : '')
      +   '<div class="fp-pdp-ritual__price">' + (o.from ? '<span class="fp-pdp-ritual__from">From</span> ' : '') + '<strong data-fp-kit-price>' + fpMoneyShort(o.pay) + '</strong> <span class="fp-pdp-kit__sep"><s data-fp-kit-sep>' + fpMoneyShort(o.sep) + '</s> separately</span> <span class="fp-pdp-ritual__badge">Save&nbsp;<span data-fp-kit-save>' + fpMoneyShort(o.save) + '</span></span></div>'
      +   '<ul class="fp-pdp-kit__pts">' + o.pts.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>'
      + '</div>'
      + '<button type="button" class="fp-pdp-ritual__add fp-pdp-kit__add" ' + o.btn + '>' + o.btnLabel + '</button>'
      + (o.more ? '<a class="fp-pdp-kit__more" href="' + o.more + '">' + o.moreLabel + '</a>' : '')
      + '</div>';
  }
  // fiche du kit (page d'arrivée pub) : « Save $49 vs. $238 bought separately » sous le prix, suit la variante
  function fpKitPageRefresh() {
    if (!_fpKitData || !document.querySelector('[data-fp-kit-page]')) return;
    var pp = document.querySelector('.product-information product-price'); if (!pp) return;
    var input = document.querySelector('.product-information form[action*="/cart/add"] [name="id"]');
    var vid = input && String(input.value);
    var kv = (_fpKitData.kit.variants || []).filter(function (v) { return String(v.id) === vid; })[0] || _fpKitData.kit.variants[0];
    var P = fpKitPrices(_fpKitData, _fpIdxOf(_fpKitData.kit, 0, kv.option1), _fpIdxOf(_fpKitData.kit, 1, kv.option2));
    var el = document.querySelector('[data-fp-kit-pagesave]');
    if (!P || P.save <= 0) { if (el) el.remove(); return; }
    var html = '<span class="fp-pdp-ritual__badge">Save&nbsp;' + fpMoneyShort(P.save) + '</span> <span>vs. <s>' + fpMoneyShort(P.sep) + '</s> bought separately</span>';
    if (!el || el.previousElementSibling !== pp) { if (el) el.remove(); el = document.createElement('p'); el.className = 'fp-pdp-kit__pagesave'; el.setAttribute('data-fp-kit-pagesave', ''); pp.insertAdjacentElement('afterend', el); }
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  // résumé d'avis vide (« 0 · 0 reviews ») masqué sur la fiche du kit tant qu'il n'a aucun avis
  function fpKitHideEmptyStars() {
    var s = document.querySelector('.product-information .AirReviews-Widget--AppBlockSummary');
    var t = String((s && s.innerText) || '').replace(/[^0-9a-z]+/gi, ' ').trim().toLowerCase();
    if (s && (t === '0 0 reviews' || t === '0 reviews' || t === '0 0 review')) s.style.display = 'none';
  }
  async function buildBrewKitHero(current) {
    var curId = current ? String(current.id) : '';
    if (curId === FP_KIT.id) {
      document.body.setAttribute('data-fp-kit-page', '');
      _fpKitData = await fpLoadKit(); if (_fpKitData) fpKitPageRefresh();
      [0, 1500, 4000, 8000].forEach(function (t) { setTimeout(fpKitHideEmptyStars, t); });
      return '';
    }
    if (curId !== FP_KIT.press && curId !== FP_KIT.grinder) return '';
    if (document.querySelector('[data-fp-gift]')) return ''; /* 13/10/26 fp-gift: kit masqué pendant l'offre moulin offert, inutile de charger catalogue + fiches */
    var K = _fpKitData = await fpLoadKit(); if (!K) return '';
    var sel = fpKitSelection(K, curId);
    var P = fpKitPrices(K, sel.si, sel.ci);
    if (!P || P.save <= 0) return '';                       // jamais d'économie nulle ou fausse
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fpCardHTML({
      attrs: 'data-fp-kit data-fp-kit-cur="' + curId + '"',
      eyebrow: 'Frequently bought together',
      title: (curId === FP_KIT.grinder ? 'Add the press' : 'Add the grinder') + ', save ' + fpMoneyShort(P.save) + '.',
      thumbs: [{ href: root + 'products/' + K.press.handle, src: fpImg(K.press), alt: 'The Signature Stainless Steel French Press' }, { href: root + 'products/' + K.grinder.handle, src: fpImg(K.grinder), alt: 'The Precision Manual Grinder' }],
      name: 'The Brew Kit', sub: 'Signature press + Precision burr grinder',
      from: curId === FP_KIT.grinder, pay: P.kit, sep: P.sep, save: P.save,
      pts: ['Burr-ground beans for a cleaner, fuller cup', 'Grind dial from espresso-fine to press-coarse', fpShipLine(P.kit)],
      btn: 'data-fp-kit-open', btnLabel: 'Add the Brew Kit',
      more: root + 'products/' + K.handles[0], moreLabel: 'See what\'s in the kit'
    });
  }
  // la presse change de taille (ou le moulin de couleur) : prix et économie du bloc suivent
  function fpKitRefresh() {
    fpKitPageRefresh();
    var el = document.querySelector('[data-fp-kit]'); if (!el || !_fpKitData) return;
    var sel = fpKitSelection(_fpKitData, el.getAttribute('data-fp-kit-cur'));
    var P = fpKitPrices(_fpKitData, sel.si, sel.ci); if (!P || P.save <= 0) return;
    var set = function (q, t) { Array.prototype.forEach.call(document.querySelectorAll(q), function (n) { if (n.textContent !== t) n.textContent = t; }); };
    set('[data-fp-kit-price]', fpMoneyShort(P.kit)); set('[data-fp-kit-sep]', fpMoneyShort(P.sep)); set('[data-fp-kit-save]', fpMoneyShort(P.save));
  }
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.product-information')) setTimeout(fpKitRefresh, 350); }, true);
  document.addEventListener('variant:update', function () { setTimeout(fpKitRefresh, 200); });
  // URLs des assets data dérivées du src de fp-pdp.js (même dossier /assets/, zéro Liquid)
  function fpAssetUrl(name) {
    var s = document.querySelector('script[src*="fp-pdp.js"]');
    if (!s || !s.src) return '/' + name;
    var ver = (s.src.match(/[?&]v=([^&]+)/) || [])[1] || '';
    var base = s.src.replace(/fp-pdp\.js(\?.*)?$/, name);
    // cache-bust : ?v du déploiement + bucket journalier (sinon le CDN sert une version périmée du JSON, et les MAJ n8n ne se propagent pas)
    return base + '?v=' + ver + '&d=' + Math.floor(Date.now() / 86400000);
  }
  var fpDataPromise = null;
  function fpFetchData() {
    if (fpDataPromise) return fpDataPromise;
    fpDataPromise = Promise.all([
      fetch(fpAssetUrl('fp-affinity.json')).then(function(r){ return r.json(); }).catch(function(){ return {}; }),
      fetch(fpAssetUrl('fp-bundles.json')).then(function(r){ return r.json(); }).catch(function(){ return { bundles: [] }; })
    ]).then(function(res){ return { aff: res[0] || {}, bun: res[1] || { bundles: [] } }; })
      .catch(function(){ return { aff: {}, bun: { bundles: [] } }; });
    return fpDataPromise;
  }

  // Bandeau bundle — réutilise les tokens/classes design du clook. Choisit le bundle le plus pertinent.
  async function buildRitualHero(bundles, current, curCat) {
    if (!bundles || !bundles.length) return '';
    var curId = current ? String(current.id) : '';
    var pick = null;
    for (var i = 0; i < bundles.length; i++) {
      var b = bundles[i];
      if (b.handle && location.pathname.indexOf('/products/' + b.handle) >= 0) continue; // jamais sur sa propre page
      var ids = (b.components || []).map(function(c){ return String(c.id); });
      if (curId && ids.indexOf(curId) >= 0) { pick = b; break; }   // current EST un composant du bundle curé → on le montre
    }
    if (!pick) return '';
    var K = await fpLoadBundle(String(pick.product_id), pick.handle, pick.components || [], pick.savePct || 0);
    if (!K) return '';
    var best = fpBundleBest(K);
    if (!best || best.save <= 0) return '';                 // pas d'économie réelle -> pas de bloc
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var isRitual = pick.handle === 'the-morning-ritual';
    return fpCardHTML({
      attrs: 'data-fp-ritual-card',
      eyebrow: 'Frequently bought together',
      title: 'Complete the ritual, save ' + fpMoneyShort(best.save) + '.',
      thumbs: K.comps.map(function (p) { return { href: root + 'products/' + p.handle, src: fpImg(p), alt: p.title }; }),
      name: pick.title,
      sub: isRitual ? 'Signature press + Precision grinder + milk frother' : K.comps.map(function (p) { return String(p.title || '').replace(/^The /, ''); }).join(' + '),
      from: (K.kit.variants || []).length > 1, pay: best.kit, sep: best.sep, save: best.save,
      pts: [(pick.savePct ? pick.savePct + '% off applied automatically at checkout' : 'Priced below the three bought separately'), 'Pick sizes and colors in the next step', fpShipLine(best.kit)],
      btn: 'data-fp-ritual-open="' + escapeHTML(pick.handle) + '"', btnLabel: isRitual ? 'Add the ritual' : 'Add the set',
      more: root + 'products/' + K.handles[0], moreLabel: isRitual ? 'See what\'s in the ritual' : 'See the set'
    });
  }

  // Bundle DYNAMIQUE par produit : current + 2 meilleurs co-achats éligibles, -15% via remise auto "3 items".
  async function buildDynamicSet(current, products, eligibleSet, savePct) {
    if (!current) return '';
    var curId = String(current.id);
    var curCat = fpCategoryOf(current);
    if (curId === FP_KIT.id) return '';                  // fiche du Brew Kit : pas de set dynamique
    if (!eligibleSet[curId]) return '';                 // current pas éligible → pas de promesse -15%
    // Composition maligne : un set complet = un grinder + un autre rôle (jamais 2 brewers redondants).
    var comps = [];
    var ROLE = { tea: 'kettle' };                 // tea-kettle et brewing-kettle = meme role (evite 2 bouilloires)
    var roleK = function (c) { return ROLE[c] || c; };
    var usedCats = {};
    usedCats[roleK(curCat)] = 1;
    function addFrom(filter) {
      for (var i = 0; i < products.length && comps.length < 2; i++) {
        var p = products[i];
        if (!eligibleSet[String(p.id)]) continue;
        var pc = fpCategoryOf(p);
        if (usedCats[roleK(pc)]) continue;
        if (filter && !filter(pc)) continue;
        comps.push(p); usedCats[roleK(pc)] = 1;
      }
    }
    if (curCat !== 'grinder') addFrom(function (c) { return c === 'grinder'; }); // grinder = essentiel du rituel
    addFrom(function (c) { return c !== 'grinder'; });                            // + un autre rôle (pas un 2e grinder)
    addFrom(null);                                                               // complète si besoin
    if (comps.length < 2) return '';
    var rootD = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var setItems = [current].concat(comps);
    // prix localisés (product.js) ; la remise auto « 3 articles » s'applique ligne par ligne, arrondie au centime
    var _locLoaded = await Promise.all(setItems.map(function (p) { return _fpLoadProduct(rootD, p.handle); }));
    if (_locLoaded.some(function (d) { return !d || !d.variants || !d.variants.length; })) return '';
    var firstAvail = function (d) { return d.variants.filter(function (v) { return v.available; })[0] || d.variants[0]; };
    var setCents = 0, offCents = 0;
    _locLoaded.forEach(function (d) { var v = firstAvail(d); setCents += v.price; offCents += Math.round(v.price * savePct / 100); });
    if (!setCents || offCents <= 0) return '';
    var payCents = setCents - offCents;
    var short = function (p) { return String(p.title || '').replace(/^The /, ''); };
    return fpCardHTML({
      attrs: 'data-fp-set-card',
      eyebrow: 'Complete the set',
      title: 'Buy all three, save ' + fpMoneyShort(offCents) + '.',
      thumbs: _locLoaded.map(function (d) { return { href: rootD + 'products/' + d.handle, src: fpImg(d), alt: d.title }; }),
      name: 'Build your set', sub: _locLoaded.map(short).join(' + '),
      from: _locLoaded.some(function (d) { return d.variants.length > 1; }), pay: payCents, sep: setCents, save: offCents,
      pts: [savePct + '% off applied automatically at checkout', 'Pick sizes and colors in the next step', fpShipLine(payCents)],
      btn: 'data-fp-set-open="' + escapeHTML(_locLoaded.map(function (d) { return d.handle; }).join(',')) + '" data-fp-set-save="' + savePct + '"', btnLabel: 'Choose &amp; add the set',
      more: '', moreLabel: ''
    });
  }

  // Popup de sélection rapide du bundle (variantes choisies sur place, prix localisé via product.js)
  var _ritualModalCache = {};
  var _fpBundlesData = null; // réf aux données bundles (composants cliquables dans le modal)
  // ===== MODALE BUNDLE UNIFIEE (cure + dynamique) — variantes choisies par produit =====
  async function _fpLoadProduct(root, handle) {
    if (_ritualModalCache[handle]) return _ritualModalCache[handle];
    // Retry : un .js qui ne repond pas a temps ne doit JAMAIS faire disparaitre un produit du bundle
    // (sinon la modale recalcule un prix plus bas que le bandeau). 3 tentatives + petit backoff.
    for (var attempt = 0; attempt < 3; attempt++) {
      try {
        var res = await fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        if (!res.ok) throw new Error('status ' + res.status);
        var d = await res.json();
        if (d && d.variants && d.variants.length) { _ritualModalCache[handle] = d; return d; }
        throw new Error('empty');
      } catch (e) {
        if (attempt < 2) { await new Promise(function (r) { setTimeout(r, 250 * (attempt + 1)); }); continue; }
        return null;
      }
    }
    return null;
  }
  function _fpRealOptions(data) {
    var names = (data.options || []).map(function (o) { return (typeof o === 'string') ? o : (o.name || o); });
    var out = [];
    names.forEach(function (name, i) {
      var seen = {}, vals = [];
      (data.variants || []).forEach(function (v) { var val = v['option' + (i + 1)]; if (val != null && !seen[val]) { seen[val] = 1; vals.push(val); } });
      var isPhantom = (/^title$/i.test(name)) && vals.length <= 1 && /default title/i.test(String(vals[0] || ''));
      if (!isPhantom) out.push({ index: i, name: name, values: vals });
    });
    return out;
  }
  // wrapper retro-compatible : bouton data-fp-ritual-open="<handle>" (bundle cure = 1 produit)
  async function openRitualModal(handle) {
    var bmeta = (_fpBundlesData && (_fpBundlesData.bundles || []).filter(function (x) { return x.handle === handle; })[0]) || null;
    var K = bmeta ? await fpLoadBundle(String(bmeta.product_id), bmeta.handle, bmeta.components || [], bmeta.savePct || 0) : null;
    var best = K && fpBundleBest(K);
    var isRitual = handle === 'the-morning-ritual';
    return openBundleModal({
      title: (bmeta && bmeta.title) || 'The Morning Ritual',
      eyebrow: 'Frequently bought together',
      savePct: (bmeta && bmeta.savePct) || 15,
      handles: [K ? K.handles[0] : handle],
      comps: (bmeta && bmeta.components) || null,
      kit: K,
      labels: { price: isRitual ? 'Ritual price' : 'Set price', add: isRitual ? 'Add the ritual to bag' : 'Add the set to bag', note: 'Discount applied automatically at checkout &middot; ' + (best ? fpShipLine(best.kit) : '30-day returns') }
    });
  }
  async function openBundleModal(spec) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var handles = (spec && spec.handles || []).filter(Boolean);
    if (!handles.length) return;
    var savePct = spec.savePct || 15;
    var loaded = await Promise.all(handles.map(function (h) { return _fpLoadProduct(root, h); }));
    // Si un composant a echoue, on retente UNE fois les manquants avant de renoncer.
    if (loaded.some(function (d) { return !d; })) {
      loaded = await Promise.all(handles.map(function (h, i) { return loaded[i] || _fpLoadProduct(root, h); }));
    }
    var items = [];
    loaded.forEach(function (data) { if (!data || !data.variants || !data.variants.length) return; items.push({ data: data, opts: _fpRealOptions(data), sel: [] }); });
    if (!items.length) { location.href = root + 'products/' + handles[0]; return; }
    // Garde anti-prix-faux : un bundle dynamique (>1 handle) ne doit pas s'afficher ampute d'un produit.
    // Mieux vaut renvoyer vers la fiche que montrer un prix incoherent avec le bandeau.
    if (handles.length > 1 && items.length < handles.length) { location.href = root + 'products/' + handles[0]; return; }
    var single = items.length === 1;
    var _compsData = [];
    if (single && spec.comps && spec.comps.length) {
      var _compHandles = await Promise.all(spec.comps.map(function (c) { return fpResolveHandle(c.id, c.handle); }));
      _compsData = (await Promise.all(_compHandles.map(function (h) { return _fpLoadProduct(root, h); }))).filter(Boolean);
    }
    items.forEach(function (it) {
      var first = (it.data.variants.find(function (v) { return v.available; }) || it.data.variants[0]);
      it.opts.forEach(function (o) { it.sel[o.index] = first['option' + (o.index + 1)]; });
      // préselection (Brew Kit : taille et couleur déjà choisies sur la fiche)
      if (spec.preselect) it.opts.forEach(function (o) { var w = spec.preselect[o.index]; if (w == null) return; var m = o.values.filter(function (x) { return _fpNrm(x) === _fpNrm(w); })[0]; if (m) it.sel[o.index] = m; });
    });
    var L = spec.labels || {};
    // prix affichés = prix facturés. Bundle natif : prix payé vs vraie somme des pièces. Set : -savePct % par ligne, au centime.
    function modalPrices() {
      if (spec.kit && single) {
        var kv = resolveVariant(items[0]); if (!kv) return null;
        var n = ((spec.kit.kit && spec.kit.kit.options) || []).length, idxs = [];
        for (var oi = 0; oi < n; oi++) idxs.push(_fpIdxOf(spec.kit.kit, oi, kv['option' + (oi + 1)]));
        var P = fpBundlePrices(spec.kit, idxs);
        return P ? { full: P.sep, disc: P.kit } : null;
      }
      var full = 0, off = 0;
      items.forEach(function (it) { var v = resolveVariant(it); if (v) { full += v.price; off += Math.round(v.price * savePct / 100); } });
      return full ? { full: full, disc: full - off } : null;
    }
    function addLabelFor(anyUnavailable, allResolved) { return anyUnavailable ? 'One item is sold out' : (!allResolved ? 'Select your options' : (L.add || (single ? 'Add to bag' : 'Add the set to bag'))); }
    function resolveVariant(it) {
      if (!it.opts.length) return it.data.variants[0];
      return it.data.variants.find(function (v) { return it.opts.every(function (o) { return v['option' + (o.index + 1)] === it.sel[o.index]; }); }) || null;
    }
    function _fpNrmVal(s) { return String(s == null ? '' : s).replace(/[  ]/g, ' ').trim(); }
    function groupCompImg(o, it) {
      if (!_compsData.length) return '';
      var comp = null;
      for (var ci = 0; ci < _compsData.length; ci++) {
        var cd = _compsData[ci];
        var match = _fpRealOptions(cd).some(function (op) { var nv = op.values.map(_fpNrmVal); return o.values.every(function (v) { return nv.indexOf(_fpNrmVal(v)) >= 0; }); });
        if (match) { comp = cd; break; }
      }
      if (!comp) return '';
      var selVal = _fpNrmVal(it.sel[o.index]);
      var v = (comp.variants || []).find(function (vv) { return (_fpNrmVal(vv.option1) === selVal || _fpNrmVal(vv.option2) === selVal || _fpNrmVal(vv.option3) === selVal) && vv.featured_image && vv.featured_image.src; });
      var img = (v && v.featured_image.src) || comp.featured_image || (comp.images && comp.images[0]) || '';
      if (!img) return '';
      var src = img + (String(img).indexOf('?') >= 0 ? '&' : '?') + 'width=140';
      return '<img class="fp-ritual-modal__group-img" src="' + src + '" alt="' + escapeHTML(comp.title || '') + '" loading="lazy" width="54" height="64">';
    }
    function optGroups(it, ii) {
      return it.opts.map(function (o) {
        var btns = o.values.map(function (val) {
          var hasAvail = it.data.variants.some(function (v) {
            return v.available && v['option' + (o.index + 1)] === val
              && it.opts.every(function (x) { return x.index === o.index || v['option' + (x.index + 1)] === it.sel[x.index]; });
          });
          var cls = 'fp-ritual-modal__opt' + (it.sel[o.index] === val ? ' is-sel' : '') + (hasAvail ? '' : ' is-soldout');
          return '<button type="button" class="' + cls + '" data-item="' + ii + '" data-opt="' + o.index + '" data-val="' + escapeHTML(val) + '"' + (hasAvail ? '' : ' aria-disabled="true"') + '>' + escapeHTML(val) + '</button>';
        }).join('');
        var gImg = single ? groupCompImg(o, it) : '';
        return '<div class="fp-ritual-modal__group' + (gImg ? ' fp-ritual-modal__grouprow' : '') + '" data-item="' + ii + '" data-optidx="' + o.index + '">' + gImg + '<div class="fp-ritual-modal__group-main"><span class="fp-ritual-modal__label">' + escapeHTML(o.name) + '</span><div class="fp-ritual-modal__opts">' + btns + '</div></div></div>';
      }).join('');
    }
    function renderBody() {
      var totalCents = 0, allResolved = true, anyUnavailable = false;
      var productsHTML = items.map(function (it, ii) {
        var variant = resolveVariant(it);
        if (!variant) allResolved = false;
        if (variant && !variant.available) anyUnavailable = true;
        if (variant) totalCents += variant.price;
        var groups = optGroups(it, ii);
        var oosNote = (variant && !variant.available) ? '<span class="fp-ritual-modal__oos">Currently sold out</span>' : '';
        if (single) return groups + oosNote;
        var img = (variant && variant.featured_image && variant.featured_image.src) || it.data.featured_image || (it.data.images && it.data.images[0]) || '';
        var src = img ? (img + (String(img).indexOf('?') >= 0 ? '&' : '?') + 'width=120') : '';
        return '<div class="fp-ritual-modal__product" data-item="' + ii + '">'
          + '<div class="fp-ritual-modal__product-head">'
          +   (src ? '<img class="fp-ritual-modal__product-img" src="' + src + '" alt="' + escapeHTML(it.data.title) + '" loading="lazy" width="44" height="54">' : '')
          +   '<a class="fp-ritual-modal__product-name" href="' + root + 'products/' + it.data.handle + '">' + escapeHTML((it.data.title || '').replace(/^The /, '')) + '</a>'
          +   oosNote
          + '</div>'
          + (groups ? '<div class="fp-ritual-modal__product-opts">' + groups + '</div>' : '')
          + '</div>';
      }).join('');
      var MP = modalPrices();
      var saveBlock = (totalCents && MP && MP.full > MP.disc)
        ? '<div class="fp-ritual-modal__save">'
          + '<div class="fp-ritual-modal__pricewrap"><span class="fp-ritual-modal__bundle-label">' + (L.price || (single ? 'Bundle price' : 'Set price')) + '</span><s>' + fpMoneyShort(MP.full) + '</s><strong>' + fpMoneyShort(MP.disc) + '</strong></div>'
          + '<div class="fp-ritual-modal__save-amt"><span class="fp-ritual-modal__save-money">You save <span data-fp-save-amt>' + fpMoneyShort(MP.full - MP.disc) + '</span></span><span class="fp-ritual-modal__save-pct">vs. buying separately</span></div>'
          + '</div>'
        : '';
      var variantIds = allResolved ? items.map(function (it) { var v = resolveVariant(it); return v ? v.id : ''; }).filter(Boolean) : [];
      var canAdd = allResolved && !anyUnavailable && variantIds.length === items.length;
      var addLabel = addLabelFor(anyUnavailable, allResolved);
      var addBtn = '<button type="button" class="fp-ritual-modal__add" data-fp-bundle-add="' + variantIds.join(',') + '"' + (canAdd ? '' : ' disabled aria-disabled="true"') + '>' + addLabel + '</button>';
      var note = '<p class="fp-ritual-modal__note">' + (L.note || ('Discount applied automatically at checkout &middot; Free shipping over ' + fpMoneyShort(fpFreeShipCents()))) + '</p>';
      var body = single ? (saveBlock + productsHTML) : (saveBlock + '<div class="fp-ritual-modal__products">' + productsHTML + '</div>');
      return body + addBtn + note;
    }
    var compRow = '';
    if (spec.comps && spec.comps.length && !(single && _compsData.length)) {
      compRow = '<div class="fp-ritual-modal__comps">' + spec.comps.map(function (c) {
        var s = c.image ? (c.image + (c.image.indexOf('?') >= 0 ? '&' : '?') + 'width=120') : '';
        return '<a href="' + root + 'products/' + c.handle + '" class="fp-ritual-modal__comp" title="' + escapeHTML(c.title) + '"><img src="' + s + '" alt="' + escapeHTML(c.title) + '" loading="lazy" width="44" height="54"><span>' + escapeHTML(c.title.replace(/^The /, '')) + '</span></a>';
      }).join('') + '</div>';
    }
    var prev = document.querySelector('.fp-ritual-modal-overlay'); if (prev) prev.remove();
    var overlay = document.createElement('div');
    overlay.className = 'fp-ritual-modal-overlay';
    overlay.innerHTML = '<div class="fp-ritual-modal" role="dialog" aria-modal="true" aria-label="' + escapeHTML(spec.title || 'Build your ritual') + '">'
      + '<div class="fp-ritual-modal__head">'
      +   '<span class="fp-ritual-modal__grip" aria-hidden="true"></span>'
      +   '<span class="fp-ritual-modal__eyebrow">' + escapeHTML(spec.eyebrow || ('Save ' + savePct + '% together')) + '</span>'
      +   '<div class="fp-ritual-modal__titlerow">'
      +     '<div class="fp-ritual-modal__title">' + escapeHTML(spec.title || 'Build your ritual') + '</div>'
      +     '<button type="button" class="fp-ritual-modal__close" aria-label="Close">&times;</button>'
      +   '</div>'
      + '</div>'
      + '<div class="fp-ritual-modal__body">' + compRow + renderBody() + '</div>'
      + '</div>';
    // Scroll-lock SANS layout-shift : on fige la page à sa position exacte (sinon la galerie image sticky "saute").
    var _scrollY = window.scrollY || window.pageYOffset || 0;
    var _sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.appendChild(overlay);
    if (!document.body.classList.contains('fp-modal-open')) {
      document.body.dataset.fpScrollY = String(_scrollY);
      document.body.classList.add('fp-modal-open');
      document.body.style.top = (-_scrollY) + 'px';
      if (_sbw > 0) document.body.style.paddingRight = _sbw + 'px';
    }
    var bodyEl = overlay.querySelector('.fp-ritual-modal__body');
    // Ecrit une valeur texte SANS remplacer le noeud (characterData only), pour que le widget
    // de traduction ne voie pas une mutation childList et ne repasse pas la zone en anglais.
    function setText(el, txt) {
      if (!el) return;
      if (el.firstChild && el.firstChild.nodeType === 3) { if (el.firstChild.nodeValue !== txt) el.firstChild.nodeValue = txt; }
      else if (el.textContent !== txt) el.textContent = txt;
    }
    function updateBody() {
      var totalCents = 0, allResolved = true, anyUnavailable = false;
      items.forEach(function (it, ii) {
        var variant = resolveVariant(it);
        if (!variant) allResolved = false;
        if (variant && !variant.available) anyUnavailable = true;
        if (variant) totalCents += variant.price;
        it.opts.forEach(function (o) {
          Array.prototype.forEach.call(bodyEl.querySelectorAll('[data-item="' + ii + '"][data-opt="' + o.index + '"]'), function (btn) {
            var val = btn.getAttribute('data-val');
            var hasAvail = it.data.variants.some(function (v) {
              return v.available && v['option' + (o.index + 1)] === val
                && it.opts.every(function (x) { return x.index === o.index || v['option' + (x.index + 1)] === it.sel[x.index]; });
            });
            btn.classList.toggle('is-sel', it.sel[o.index] === val);
            btn.classList.toggle('is-soldout', !hasAvail);
            if (hasAvail) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
          });
          var grp = bodyEl.querySelector('.fp-ritual-modal__group[data-item="' + ii + '"][data-optidx="' + o.index + '"]');
          var gi = grp && grp.querySelector('.fp-ritual-modal__group-img');
          if (gi) {
            var gh = groupCompImg(o, it);
            var gm = gh && gh.match(/src="([^"]+)"/);
            if (gm && gi.getAttribute('src') !== gm[1]) gi.setAttribute('src', gm[1]);
          }
        });
        var pimg = bodyEl.querySelector('.fp-ritual-modal__product[data-item="' + ii + '"] .fp-ritual-modal__product-img');
        if (pimg) {
          var pi = (variant && variant.featured_image && variant.featured_image.src) || it.data.featured_image || (it.data.images && it.data.images[0]) || '';
          if (pi) {
            var psrc = pi + (String(pi).indexOf('?') >= 0 ? '&' : '?') + 'width=120';
            if (pimg.getAttribute('src') !== psrc) pimg.setAttribute('src', psrc);
          }
        }
      });
      var MP = modalPrices();
      if (MP) {
        setText(bodyEl.querySelector('.fp-ritual-modal__pricewrap s'), fpMoneyShort(MP.full));
        setText(bodyEl.querySelector('.fp-ritual-modal__pricewrap strong'), fpMoneyShort(MP.disc));
        setText(bodyEl.querySelector('[data-fp-save-amt]'), fpMoneyShort(MP.full - MP.disc));
      }
      var variantIds = allResolved ? items.map(function (it) { var v = resolveVariant(it); return v ? v.id : ''; }).filter(Boolean) : [];
      var canAdd = allResolved && !anyUnavailable && variantIds.length === items.length;
      var add = bodyEl.querySelector('[data-fp-bundle-add]');
      if (add) {
        add.setAttribute('data-fp-bundle-add', variantIds.join(','));
        add.disabled = !canAdd;
        if (canAdd) add.removeAttribute('aria-disabled'); else add.setAttribute('aria-disabled', 'true');
        // Le libelle n'est reecrit QUE s'il change reellement d'etat : sinon on repasserait
        // en anglais un texte deja traduit par le widget.
        var wanted = addLabelFor(anyUnavailable, allResolved);
        if (add.dataset.fpLabelState !== wanted) { setText(add, wanted); add.dataset.fpLabelState = wanted; }
      }
    }
    function rerender() { updateBody(); }
    function escH(e) { if (e.key === 'Escape') close(); }
    function close() { overlay.remove(); document.removeEventListener('keydown', escH); if (document.querySelector('.fp-ritual-modal-overlay')) { return; } var _sy = parseInt(document.body.dataset.fpScrollY || '0', 10) || 0; document.body.classList.remove('fp-modal-open'); document.body.style.top = ''; document.body.style.paddingRight = ''; delete document.body.dataset.fpScrollY; window.scrollTo({ top: _sy, left: 0, behavior: 'instant' }); }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.fp-ritual-modal__close')) { close(); return; }
      var opt = e.target.closest('[data-opt]');
      if (opt) {
        if (opt.getAttribute('aria-disabled') === 'true') return;
        items[+opt.getAttribute('data-item')].sel[+opt.getAttribute('data-opt')] = opt.getAttribute('data-val');
        rerender(); return;
      }
      var add = e.target.closest('[data-fp-bundle-add]');
      if (add) {
        if (add.disabled) return;
        var ids = (add.getAttribute('data-fp-bundle-add') || '').split(',').filter(Boolean);
        if (ids.length !== items.length) { rerender(); return; }
        add.textContent = 'Adding...'; add.disabled = true;
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (res) { document.dispatchEvent(new CustomEvent('cart:updated')); /* 07/10/26 : ouvre le tiroir au lieu de /cart */ try { close(); } catch (_) {} import('@theme/events').then(function (m) { document.dispatchEvent(new m.CartAddEvent({}, 'fp-kit', { source: 'fp-kit', itemCount: ids.length })); setTimeout(function () { var d = document.querySelector('cart-drawer-component'); var dl = d && d.querySelector('dialog'); if (d && !(dl && dl.open) && d.open) d.open(); }, 600); }).catch(function () { location.href = root + 'cart'; }); })
          .catch(function () { add.textContent = 'Try again'; add.disabled = false; });
        return;
      }
    });
    document.addEventListener('keydown', escH);
  }

  async function buildCompleteLook() {
    if (document.querySelector('[data-fp-avril-bundle]')) return ''; /*AVRIL*/
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var pid = meta && meta.product && meta.product.id;
    var pHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';

    var catalog = await fpFetchCatalog();
    if (!catalog.length) return '';

    // Find current product in the catalog (by id or handle)
    var current = null;
    for (var i = 0; i < catalog.length; i++) {
      if ((pid && catalog[i].id == pid) || (pHandle && catalog[i].handle === pHandle)) {
        current = catalog[i];
        break;
      }
    }
    var currentCat = fpCategoryOf(current || { title: document.title, product_type: meta && meta.product && meta.product.type });
    var prefs = FP_COMPLEMENTS[currentCat] || FP_COMPLEMENTS['other'];

    // Bundle Intelligence data (co-purchase affinity + active bundles) — fed by n8n
    var DATA = RITUAL_ON ? await fpFetchData() : { aff: {}, bun: { bundles: [] } };
    _fpBundlesData = DATA.bun;
    var AFF = DATA.aff || {};
    var curId = current ? String(current.id) : '';

    // Candidats : compléments (règles) + items fortement co-achetés (data), hors concurrents et hors bundles
    var affForCur = (RITUAL_ON && AFF.affinity && curId && AFF.affinity[curId]) || {};
    var bundleHandles = {};
    ((DATA.bun && DATA.bun.bundles) || []).forEach(function(b){ if (b.handle) bundleHandles[b.handle] = 1; });
    var candidates = [];
    for (var j = 0; j < catalog.length; j++) {
      var p = catalog[j];
      if (!p || (current && p.id === current.id)) continue;
      if (p.published_at === null) continue; // unpublished
      if (!p.variants || !p.variants.length) continue;
      if (bundleHandles[p.handle]) continue;     // ne pas reproposer un bundle dans le carrousel
      if (String(p.id) === FP_KIT.id || p.handle === FP_KIT.handle) continue; // ni le Brew Kit
      var cat = fpCategoryOf(p);
      if (cat === currentCat) continue;          // never competing
      var idx = prefs.indexOf(cat);
      var coBuy = affForCur[String(p.id)] || 0;
      if (idx === -1 && coBuy < 2) continue;      // ni complément-règle, ni co-acheté → skip
      candidates.push({ p: p, cat: cat, score: idx === -1 ? prefs.length : idx, coBuy: coBuy });
    }

    // Sort: complementarity preference, then REAL data (co-purchase affinity, then sales popularity), then recency
    var affMap = (AFF.affinity && curId && AFF.affinity[curId]) || null;
    var popMap = AFF.popularity || null;
    candidates.sort(function(a, b) {
      if (a.score !== b.score) return a.score - b.score;
      if (RITUAL_ON) {
        if (affMap) {
          var fa = affMap[String(a.p.id)] || 0, fb = affMap[String(b.p.id)] || 0;
          if (fa !== fb) return fb - fa;          // co-achat réel d'abord
        }
        if (popMap) {
          var pa = popMap[String(a.p.id)] || 0, pb = popMap[String(b.p.id)] || 0;
          if (pa !== pb) return pb - pa;          // puis ventes réelles
        }
      }
      return new Date(b.p.updated_at || 0) - new Date(a.p.updated_at || 0); // fallback récence
    });

    // Diversifie pour la VARIÉTÉ : round-robin par catégorie (le meilleur de chaque d'abord), pas 3 fois la même.
    var byCat = {};
    for (var k = 0; k < candidates.length; k++) {
      var c = candidates[k];
      (byCat[c.cat] = byCat[c.cat] || []).push(c); // déjà triés (affinité/préférence)
    }
    var catOrder = Object.keys(byCat).sort(function(a, b) {
      return byCat[a][0].score - byCat[b][0].score; // catégorie par sa meilleure préférence
    });
    var picked = [];
    var round = 0;
    while (picked.length < 10 && round < 8) {
      var added = false;
      for (var ci = 0; ci < catOrder.length && picked.length < 10; ci++) {
        var arr = byCat[catOrder[ci]];
        if (arr[round]) { picked.push(arr[round].p); added = true; }
      }
      if (!added) break;
      round++;
    }

    var products = picked;
    if (!products.length) return '';
    function _toCents(v) {
      if (v == null || v === '') return 0;
      var s = String(v);
      return s.indexOf('.') >= 0 ? Math.round(parseFloat(s) * 100) : (parseInt(s, 10) || 0);
    }
    var _FP_COLOR_MAP = {
      'black': '#1A1008', 'noir': '#1A1008',
      'cream': '#E8DDD0', 'creme': '#E8DDD0', 'crème': '#E8DDD0', 'beige': '#E8DDD0', 'ivory': '#F0EAD8',
      'white': '#FFFFFF', 'blanc': '#FFFFFF',
      'silver': '#C0C0C0', 'argent': '#C0C0C0', 'stainless': '#A8A8A8', 'inox': '#A8A8A8',
      'gold': '#C8A96E', 'or': '#C8A96E', 'brass': '#C8A96E',
      'walnut': '#5C3D2E', 'wood': '#A0826D', 'bois': '#A0826D', 'oak': '#C7A878',
      'gray': '#808080', 'grey': '#808080', 'gris': '#808080', 'taupe': '#7A6652',
      'red': '#B8412B', 'rouge': '#B8412B', 'copper': '#B87333', 'cuivre': '#B87333',
      'green': '#5A7A4A', 'vert': '#5A7A4A',
      'blue': '#3B5378', 'bleu': '#3B5378', 'navy': '#1F2A44',
      'pink': '#E8B4B8', 'rose': '#E8B4B8',
      'brown': '#5C4636', 'marron': '#5C4636', 'chocolate': '#3D2817'
    };
    function _fpColorFor(name) {
      var key = String(name || '').toLowerCase().trim();
      if (_FP_COLOR_MAP[key]) return _FP_COLOR_MAP[key];
      var parts = key.split(/\s+/);
      if (_FP_COLOR_MAP[parts[0]]) return _FP_COLOR_MAP[parts[0]];
      if (_FP_COLOR_MAP[parts[parts.length - 1]]) return _FP_COLOR_MAP[parts[parts.length - 1]];
      return '#C0C0C0';
    }
    function _buildClookSwatches(p, productUrl) {
      var opts = p.options || [];
      var colorIdx = -1;
      opts.forEach(function(o, i) {
        var name = (typeof o === 'string' ? o : (o.name || ''));
        if (/color|colour|couleur/i.test(name)) colorIdx = i;
      });
      if (colorIdx === -1) return '';
      var seen = {};
      var dots = [];
      (p.variants || []).forEach(function(va) {
        var val = va['option' + (colorIdx + 1)];
        if (!val || seen[val]) return;
        seen[val] = true;
        var url = productUrl + '?variant=' + va.id;
        var hex = _fpColorFor(val);
        dots.push('<a href="' + url + '" class="fp-pdp-clook__swatch" title="' + val + '" style="background-color:' + hex + '"></a>');
      });
      if (dots.length < 2) return '';
      return '<div class="fp-pdp-clook__swatches">' + dots.join('') + '</div>';
    }
    var slides = products.map(function(p) {
      var v = p.variants && p.variants[0]; if (!v) return '';
      var imgRaw = (p.images && p.images[0]) || p.featured_image || '';
      var img = typeof imgRaw === 'object' && imgRaw !== null ? (imgRaw.src || imgRaw.url || '') : imgRaw;
      var cents = _toCents(v.price);
      var cmpCents = _toCents(v.compare_at_price);
      var onSale = cmpCents > cents && cents > 0;
      var pct = onSale ? Math.round((1 - cents / cmpCents) * 100) : 0;
      var url = (window.Shopify.routes.root + 'products/') + p.handle;
      var priceHTML = onSale
        ? '<div class="fp-pdp-clook__price fp-pdp-clook__price--sale"><s>' + fpFormatMoney(cmpCents) + '</s> <strong>' + fpFormatMoney(cents) + '</strong></div>'
        : '<div class="fp-pdp-clook__price">' + fpFormatMoney(cents) + '</div>';
      var badgeHTML = onSale
        ? '<span class="fp-pdp-clook__badge">-' + pct + '%</span>'
        : '';
      return '<div class="fp-pdp-clook__card">'
        + '<a href="' + url + '" class="fp-pdp-clook__media-link" aria-label="' + p.title + '">'
        +   '<div class="fp-pdp-clook__media">' + badgeHTML + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="320" height="320">' : '') + '</div>'
        + '</a>'
        + '<div class="fp-pdp-clook__body">'
        +   '<a href="' + url + '" class="fp-pdp-clook__name">' + p.title + '</a>'
        +   priceHTML
        + '</div>'
        + '<button type="button" class="fp-pdp-clook__add" data-variant-id="' + v.id + '">Add to bag</button>'
        + '</div>';
    }).join('');
    var ritualHTML = '';
    if (RITUAL_ON) {
      try { ritualHTML = await buildBrewKitHero(current); } catch (eK) { ritualHTML = ''; } // presse Signature / moulin Precision -> The Brew Kit
      if (!ritualHTML) { try { ritualHTML = await buildRitualHero((DATA.bun && DATA.bun.bundles) || [], current, currentCat); } catch (eR) { ritualHTML = ''; } } // bundle curé (Morning Ritual)
      if (!ritualHTML) {                                  // sinon, set dynamique propre à ce produit
        var eligibleSet = {};
        ((DATA.bun && DATA.bun.eligible) || []).forEach(function (id) { eligibleSet[String(id)] = 1; });
        ritualHTML = await buildDynamicSet(current, products, eligibleSet, (DATA.bun && DATA.bun.dynamicSavePct) || 15);
      }
    }
    if (!ritualHTML) return '';   // plus de carrousel : pas de bundle pertinent → pas de section
    return '<div class="fp-pdp-clook" data-fp-pdp-clook>'
      + '<div class="fp-pdp-clook__head">'
      + '<div class="fp-pdp-clook__head-text">'
      + '<span class="fp-pdp-clook__eyebrow">' + ((ritualHTML.match(/data-fp-eyebrow="([^"]*)"/) || [])[1] || 'Frequently bought together') + '</span>'
      + '<span class="fp-pdp-clook__title">' + (function () {
          var t = (ritualHTML.match(/data-fp-title="([^"]*)"/) || [])[1] || 'Complete your ritual &amp; save.';
          var sv = (ritualHTML.match(/data-fp-kit-save>([^<]+)</) || [])[1];
          return (sv && ritualHTML.indexOf('data-fp-kit ') >= 0) ? t.replace(sv, '<span data-fp-kit-save>' + sv + '</span>') : t;
        })() + '</span>'
      + '</div>'
      + '</div>'
      + ritualHTML
      + '</div>';
  }

  function fpCountdownText() {
    // 6h cycle matching cart drawer (next 00/06/12/18)
    var now = new Date();
    var next = new Date(now);
    var nh = (Math.floor(now.getHours() / 6) + 1) * 6;
    if (nh >= 24) { next.setDate(next.getDate() + 1); next.setHours(0,0,0,0); } else { next.setHours(nh,0,0,0); }
    var diff = Math.max(0, next - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    function p2(n){ return (n < 10 ? '0' : '') + n; }
    return h + 'h ' + p2(m) + 'min ' + p2(s) + 's';
  }

  function buildPromise() {
    return '<div class="fp-pdp-promise" data-fp-pdp-promise>'
      + '<div class="fp-pdp-promise__head">'
      + '<span class="fp-pdp-promise__eyebrow">French Press promise</span>'
      + '<span class="fp-pdp-promise__title">Brewed today, on its way</span>'
      + '</div>'
      + '<div class="fp-pdp-promise__row">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>'
      + '<div class="fp-pdp-promise__col">'
      + '<span class="fp-pdp-promise__label">Priority dispatch · order in <span class="fp-pdp-promise__countdown notranslate" translate="no" data-fp-pdp-countdown>' + fpCountdownText() + '</span> ships today</span>'
      + '<span class="fp-pdp-promise__sub">Hand-checked and packed the same day, with full tracking from our atelier to your door.</span>'
      + '</div></div>'
      + '<div class="fp-pdp-promise__row">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 14v-2a9 9 0 0 1 18 0v2"/><rect x="2" y="14" width="5" height="7" rx="1"/><rect x="17" y="14" width="5" height="7" rx="1"/></svg>'
      + '<div class="fp-pdp-promise__col">'
      + '<span class="fp-pdp-promise__label">Care team · email us anytime</span>'
      + '<span class="fp-pdp-promise__sub">Drop us a line at contact@frenchpressandco.com  we read every email and reply within 24h.</span>'
      + '</div></div>'
      + '</div>';
  }

  function buildSpecs() {
    return '<div class="fp-pdp-specs" data-fp-pdp-specs>'
      + '<div class="fp-pdp-specs__item"><span class="fp-pdp-specs__label">Material</span><span class="fp-pdp-specs__value">18/10 Stainless steel</span></div>'
      + '<div class="fp-pdp-specs__item"><span class="fp-pdp-specs__label">Insulation</span><span class="fp-pdp-specs__value">Double-walled</span></div>'
      + '<div class="fp-pdp-specs__item"><span class="fp-pdp-specs__label">Care</span><span class="fp-pdp-specs__value">Dishwasher safe</span></div>'
      + '</div>';
  }

  // 2026-09-18: shipping copy below mirrors /policies/shipping-policy word for word (it used to say
  // "shipped from our atelier" and "duties handled", which the policy contradicts). Keep both in sync.
  function buildAccordion() {
    // 2026-09-18: same icon family as the trust strip (24 grid, 1.5 stroke, round joins).
    // Keys kept for the markup below: heart = coffee cup, leaf = water drop (care).
    var ICON = {
      heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v2"/><path d="M14 2v2"/><path d="M6 2v2"/><path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>',
      leaf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>'
    };
    return '<div class="fp-pdp-accordion" data-fp-pdp-accordion>'

      + '<details>'
      + '<summary><span class="fp-acc-label">' + ICON.heart + '<span>Why home baristas choose us</span></span></summary>'
      + '<div class="fp-pdp-accordion__body">'
      + '<p>We make pieces for the slow morning. Built to be picked up every day, not kept on a shelf.</p>'
      + '<ul>'
      + '<li>Designed for daily ritual, not display</li>'
      + '<li><strong>10,000+ home baristas</strong> brewing with us across <strong>35+ countries</strong></li>'
      + '<li>A small team that reads and replies to every email</li>'
      + '<li>Free worldwide shipping over ' + fpMoneyShort(fpFreeShipCents()) + ' on every order</li>'
      + '</ul>'
      + '<p>If our piece does not earn its spot in your morning, we want to know. We listen, and we make it right.</p>'
      + '</div>'
      + '</details>'

      + '<details>'
      + '<summary><span class="fp-acc-label">' + ICON.truck + '<span>Shipping &amp; delivery</span></span></summary>'
      + '<div class="fp-pdp-accordion__body">'
      + '<p>Every order is quality-checked before dispatch and shipped, fully tracked, from our partner facilities to your door.</p>'
      + '<ul>'
      + '<li><strong>Free worldwide shipping</strong> on orders over ' + fpMoneyShort(fpFreeShipCents()) + '</li>'
      + '<li>We ship to <strong>35+ countries</strong></li>'
      + '<li>Orders are processed within <strong>24 hours</strong> on business days</li>'
      + ''
      + '<li>Tracking link emailed as soon as your order ships</li>'
      + '<li>Import duties or taxes may apply depending on your country</li>'
      + '</ul>'
      + '<p>Need anything specific about your delivery? Drop us a line and we will sort it.</p>'
      + '</div>'
      + '</details>'

      + '<details>'
      + '<summary><span class="fp-acc-label">' + ICON.shield + '<span>Returns &amp; 1-year guarantee</span></span></summary>'
      + '<div class="fp-pdp-accordion__body">'
      + '<p>Every piece is built to last, and backed by our promise.</p>'
      + '<ul>'
      + '<li><strong>30-day returns</strong> on unused items</li>'
      + '<li><strong>1-year guarantee</strong> against any manufacturing defect</li>'
      + '<li>We cover the return label on faulty items</li>'
      + '<li>One email to <strong>contact@frenchpressandco.com</strong> and we take care of everything</li>'
      + '</ul>'
      + '<p>If something does not feel right, we make it right.</p>'
      + '</div>'
      + '</details>'

      + '<details>'
      + '<summary><span class="fp-acc-label">' + ICON.leaf + '<span>Care &amp; ritual</span></span></summary>'
      + '<div class="fp-pdp-accordion__body">'
      + '<p>A few simple habits keep your piece looking and brewing at its best for years to come.</p>'
      + '<ul>'
      + '<li><strong>Rinse warm</strong> after each use with mild soap. Skip abrasive sponges so the finish stays clean</li>'
      + '<li><strong>Hand-wash recommended</strong> to preserve the surface, even on dishwasher-safe parts</li>'
      + '<li><strong>Air-dry upside down</strong> on a clean cloth, away from direct sunlight</li>'
      + '<li><strong>Disassemble fully</strong> from time to time, especially the mesh and seals, for a deeper clean</li>'
      + '<li><strong>Store dry</strong> in a cool spot, never sealed wet</li>'
      + '</ul>'
      + '<p>Tip from our atelier: a quick rinse the moment you finish brewing is worth ten scrubs later. Treated kindly, our pieces become a daily companion for years.</p>'
      + '<p>Have a question about your piece? Email us at <strong>contact@frenchpressandco.com</strong>.</p>'
      + '</div>'
      + '</details>'

      + '</div>';
  }

  var fpInjectLock = false;
  // 2026-09-18: the strongest buying reasons were buried in the collapsed "Discover more"
  // accordion (first section, 4-5 "<strong>Lead:</strong> sentence" bullets on 84/85 products).
  // Surface them as a short scannable list right under the trust strip. Text is read from the
  // product description itself: nothing is written here, so no claim can drift from the PDP copy.
  function buildHighlights(details) {
    if (document.querySelector('[data-fp-avril-under]')) return ''; /*AVRIL*/
    try {
      var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      var render = function(items){
        return '<ul class="fp-pdp-highlights" data-fp-pdp-highlights>'
          + items.map(function(it){ return '<li>' + CHECK + '<span><strong>' + escapeHTML(it.lead) + '.</strong> ' + escapeHTML(it.text) + '</span></li>'; }).join('')
          + '</ul>';
      };
      // Products without a "Why..." section get their bullets from the theme snippet (written from the
      // product's own description and fact-checked, 2026-09-18).
      var dataEl = document.getElementById('fp-highlights-data');
      if (dataEl) {
        var arr = JSON.parse(dataEl.textContent || '[]');
        if (arr && arr.length >= 3) return render(arr.slice(0, 4));
      }
      var desc = details.querySelector('[class*="text_aEtTtq"]') || details.querySelector('rte-formatter');
      if (!desc) return '';
      var sec = desc.querySelector('details .fp-body-block');
      var ul = sec && sec.querySelector('ul');
      if (!ul) return '';
      // Only a benefits section qualifies. Two kits open with a "What's in the box" list instead.
      var h = sec.querySelector('h4');
      if (h && /(box|set|kit|bo[iî]te|coffret|inclu)/i.test(h.textContent || '')) return '';
      var items = [];
      ul.querySelectorAll('li').forEach(function(li){
        var st = li.querySelector('strong');
        if (!st) return;
        var lead = (st.textContent || '').replace(/[:\s]+$/, '').trim();
        var rest = (li.textContent || '').replace(st.textContent, '').replace(/\s+/g, ' ').trim();
        var m = rest.match(/^.*?[.!?](?=\s|$)/);
        var first = (m ? m[0] : rest).trim();
        if (lead && first) items.push({ lead: lead, text: first });
      });
      if (items.length < 3) return '';
      items = items.slice(0, 4);
      sec.setAttribute('data-fp-surfaced', '');
      return render(items);
    } catch (e) { return ''; }
  }

  // 2026-09-18: "why it is worth the price" block for the hero products: a short comparison against
  // the generic cheaper alternative plus what is in the box. Data comes from the theme snippet
  // (fp-compare-data); every cell restates the product's own description.
  function buildCompare(noInbox) {
    try {
      var el = document.getElementById('fp-compare-data');
      if (!el) return '';
      var d = JSON.parse(el.textContent || '{}');
      if (!d.rows || !d.rows.length) return '';
      var thumb = '';
      try {
        var ti = document.querySelector('.product-information media-gallery slideshow-slide img');
        var tsrc = ti && (ti.getAttribute('src') || '');
        if (tsrc) thumb = '<img class="fp-pdp-compare__thumb" src="' + escapeHTML(tsrc.replace(/([?&])width=\d+/, '$1width=160')) + '" alt="" loading="lazy" width="40" height="40">';
      } catch (e2) {}
      var h = '<div class="fp-pdp-compare" data-fp-pdp-compare>'
        + '<p class="fp-pdp-compare__eyebrow">How it compares</p>'
        + '<h2 class="fp-pdp-compare__title">' + escapeHTML(d.title) + '</h2>'
        + '<div class="fp-pdp-compare__table" role="table">'
        + '<div class="fp-pdp-compare__row fp-pdp-compare__row--head" role="row"><span role="columnheader"></span><span role="columnheader">' + thumb + '<b>' + escapeHTML(d.cols[0]) + '</b></span><span role="columnheader"><b>' + escapeHTML(d.cols[1]) + '</b></span></div>'
        + d.rows.map(function(r){ return '<div class="fp-pdp-compare__row" role="row"><span role="rowheader">' + escapeHTML(r[0]) + '</span><span role="cell">' + escapeHTML(r[1]) + '</span><span role="cell">' + escapeHTML(r[2]) + '</span></div>'; }).join('')
        + '</div>';
      if (d.inbox && !noInbox) h += '<p class="fp-pdp-compare__inbox"><strong>In the box.</strong> ' + escapeHTML(d.inbox) + '</p>';
      return h + '</div>';
    } catch (e) { return ''; }
  }

  // 2026-09-18 (Mathéo): the 4 bullets now do the selling, so the intro prose moves INSIDE the
  // "Discover more" accordion and stray junk lines above it are hidden. Idempotent: Horizon re-renders
  // the section on variant change and inject() runs again.
  function tidyDescription(details) {
    try {
      var desc = details.querySelector('[class*="text_aEtTtq"]') || details.querySelector('rte-formatter');
      if (!desc) return;
      var intro = null, inner = desc.querySelector('details.fp-body-discover .fp-body-discover__inner');
      Array.prototype.forEach.call(desc.children, function(k){
        if (k.classList && k.classList.contains('fp-body-intro')) intro = k;
        // leftover import lines such as "Dimensions - Capacity 41 oz . 41 oz . 3 in"
        else if (k.tagName === 'P' && /^\s*Dimensions\s*-/i.test(k.textContent || '')) k.setAttribute('data-fp-junk', '');
      });
      // when the structured intro exists, any loose <p> sitting beside it is import residue (any language)
      if (intro || inner) Array.prototype.forEach.call(desc.children, function(k){ if (k.tagName === 'P') k.setAttribute('data-fp-junk', ''); });
      if (intro && inner && !inner.contains(intro)) inner.insertBefore(intro, inner.firstChild);
    } catch (e) {}
  }

  // Full-width band between the product block and "Recently viewed": lifestyle photo, the product's own
  // tagline, its key specifications, what is in the box, and (hero products) the comparison table.
  // Everything is read from the page: gallery images, the description's blockquote and its
  // Specifications section. The band lives outside the product section, so it is built once.
  function buildStoryBand(pi, details) {
    try {
      // Never render the band unstyled. Shopify can serve a new fp-pdp.js next to a stale fp-pdp-pro.css for a
      // few minutes after a push (render nodes update one by one): the CSS sets --fp-story-ready, we wait for it.
      if (getComputedStyle(document.documentElement).getPropertyValue('--fp-story-ready').trim() !== '2') {
        if (!buildStoryBand._retry) {
          buildStoryBand._retry = true;
          window.addEventListener('load', function(){ setTimeout(function(){ buildStoryBand(pi, details); }, 400); });
        }
        return;
      }
      var desc = details.querySelector('[class*="text_aEtTtq"]') || details.querySelector('rte-formatter');
      if (!desc) return;
      // locate the Specifications section structurally: rows of two spans
      var specSec = null, rows = [];
      desc.querySelectorAll('details .fp-body-block').forEach(function(sec){
        if (specSec) return;
        var r = [];
        sec.querySelectorAll('div > div').forEach(function(d){
          var sp = d.querySelectorAll(':scope > span');
          if (sp.length === 2 && sp[0].textContent.trim() && sp[1].textContent.trim()) r.push([sp[0].textContent.trim(), sp[1].textContent.trim()]);
        });
        if (r.length >= 3) { specSec = sec; rows = r; }
      });
      var existing = document.querySelector('[data-fp-pdp-story]');
      if (existing) { if (specSec) specSec.setAttribute('data-fp-surfaced', ''); return; }
      var cmp = buildCompare(rows.length > 0);
      if (!rows.length && !cmp) return;
      var inbox = '';
      rows = rows.filter(function(r){ if (/^(in the box|dans la bo)/i.test(r[0])) { inbox = r[1]; return false; } return true; }).slice(0, 7);
      // lifestyle image: file names carry the shot type (…-03-lifestyle_parisien.png)
      var imgs = Array.prototype.map.call(pi.querySelectorAll('media-gallery slideshow-slide img'), function(i){ return i.getAttribute('src') || ''; }).filter(function(u){ return u && !/preview_images/.test(u); }); /* 02/11/26 : l'affiche d'une vidéo de galerie n'est pas une photo de section */
      var pick = imgs.filter(function(u){ return /lifestyle/i.test(u); })[0] || imgs.filter(function(u){ return /action|scale|macro/i.test(u); })[0] || imgs[1] || '';
      if (pick) pick = pick.replace(/([?&])width=\d+/, '$1width=1100');
      // second, smaller photo overlapping the first (editorial collage): a close-up when there is one
      var inset = imgs.filter(function(u){ return u !== imgs[0] && u.split('?')[0] !== (pick || '').split('?')[0] && /macro|detail|scale|action/i.test(u); })[0] || '';
      if (inset) inset = inset.replace(/([?&])width=\d+/, '$1width=600');
      var bq = desc.querySelector('blockquote');
      var h1 = details.querySelector('h1');
      var tagline = (bq && bq.textContent.trim()) || (h1 && h1.textContent.trim()) || '';
      var h = '<section class="fp-pdp-story" data-fp-pdp-story><div class="fp-pdp-story__wrap">';
      if (rows.length) {
        h += '<div class="fp-pdp-story__grid' + (pick ? '' : ' fp-pdp-story__grid--noimg') + '">'
          + (pick ? '<div class="fp-pdp-story__media' + (inset ? ' fp-pdp-story__media--duo' : '') + '"><div class="fp-pdp-story__img"><img src="' + escapeHTML(pick) + '" alt="' + escapeHTML((h1 && h1.textContent.trim()) || '') + '" loading="lazy" decoding="async"></div>' + (inset ? '<div class="fp-pdp-story__inset"><img src="' + escapeHTML(inset) + '" alt="" loading="lazy" decoding="async"></div>' : '') + '</div>' : '')
          + '<div class="fp-pdp-story__body">'
          + '<p class="fp-pdp-story__eyebrow">The details</p>'
          + '<h2 class="fp-pdp-story__title">' + escapeHTML(tagline) + '</h2>'
          + '<dl class="fp-pdp-story__specs">' + rows.map(function(r){ return '<div><dt>' + escapeHTML(r[0]) + '</dt><dd>' + escapeHTML(r[1]) + '</dd></div>'; }).join('') + '</dl>'
          + (inbox ? '<p class="fp-pdp-story__inbox"><strong>In the box.</strong> ' + escapeHTML(inbox) + '</p>' : '')
          + '</div></div>';
      }
      if (cmp) h += '<div class="fp-pdp-story__compare">' + cmp + '</div>';
      h += '</div></section>';
      var host = pi.closest('.shopify-section') || pi;
      var avSlot = document.querySelector('[data-fp-avril-story-slot]'); /*AVRIL*/
      if (avSlot) avSlot.insertAdjacentHTML('beforeend', h); else host.insertAdjacentHTML('afterend', h);
      if (specSec && rows.length) specSec.setAttribute('data-fp-surfaced', '');
    } catch (e) {}
  }

  // 2026-09-18: some products have a Color option without Shopify swatch data, so Horizon renders text
  // pills ("Black" / "Silver"). Turn them into round swatches when EVERY value of the option is a colour we
  // recognise. Values are translated on localized storefronts ("Noir", "Argenté"), hence the word lists.
  var FP_SWATCH_WORDS = [
    [/\b(black|noir|noire|schwarz|negro|nero|zwart|onyx|obsidian)\b/, '#1E1B19'],
    [/\b(white|blanc|blanche|weiss|weiß|blanco|bianco|wit|ivory|ivoire)\b/, '#F4F1EA'],
    [/\b(silver|argent|argente|silber|plata|argento|zilver|steel|acier|chrome)\b/, 'linear-gradient(135deg,#F3F4F5 0%,#B9BEC3 48%,#E4E6E8 100%)'],
    [/\b(gold|golden|or|dore|doree|oro|dorado)\b/, 'linear-gradient(135deg,#F3DFA6 0%,#C9A24E 50%,#EAD08A 100%)'],
    [/\b(bronze|copper|cuivre|kupfer)\b/, 'linear-gradient(135deg,#D9A679 0%,#9C6235 55%,#C98F5E 100%)'],
    [/\b(gray|grey|gris|grise|grau|grigio|grijs|graphite|cement|ciment)\b/, '#8A8D90'],
    [/\b(blue|bleu|bleue|blau|azul|blu|blauw|navy|marine)\b/, '#4A6A8C'],
    [/\b(cyan|turquoise|teal)\b/, '#6CC5C8'],
    [/\b(green|vert|verte|grun|grün|verde|groen|olive|sage|sauge)\b/, '#5F7A55'],
    [/\b(red|rouge|rot|rojo|rosso|rood)\b/, '#B23A2A'],
    [/\b(coral|corail|peach|peche)\b/, '#EFA58F'],
    [/\b(pink|rose|rosa|roze)\b/, '#E9B3B8'],
    [/\b(beige|cream|creme|sand|sable|nude)\b/, '#E4D5BC'],
    [/\b(brown|marron|brun|brune|braun|marrone|bruin|walnut|noyer|mahogany|chocolate|chocolat)\b/, '#7A5236']
  ];
  function fpSwatchFor(v) {
    var t = String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (/[&\/+]/.test(t)) return null;          // two-tone or "Black / US" plug variants stay as text
    for (var i = 0; i < FP_SWATCH_WORDS.length; i++) if (FP_SWATCH_WORDS[i][0].test(t)) return FP_SWATCH_WORDS[i][1];
    return null;
  }
  function swatchifyColors(root) {
    try {
      (root || document).querySelectorAll('.product-information variant-picker fieldset.variant-option').forEach(function(fs){
        var labels = fs.querySelectorAll('label.variant-option__button-label');
        if (!labels.length || fs.querySelector('.variant-option__button-label--has-swatch')) return;
        var cols = [];
        for (var i = 0; i < labels.length; i++) {
          var inp = labels[i].querySelector('input');
          var c = fpSwatchFor(inp && inp.value);
          if (!c) return;                       // one unknown value: leave the whole option as text pills
          cols.push(c);
        }
        fs.classList.add('fp-swatchified');
        labels.forEach(function(l, i){ l.classList.add('fp-sw'); l.style.setProperty('--fp-sw', cols[i]); l.title = (l.textContent || '').trim(); });
        var lg = fs.querySelector('legend');
        var checked = fs.querySelector('input:checked');
        if (lg && checked) {
          var val = lg.querySelector('.variant-option__swatch-value');
          if (!val) { val = document.createElement('span'); val.className = 'variant-option__swatch-value'; lg.appendChild(val); }
          var txt = ((checked.closest('label') || {}).textContent || checked.value || '').trim();
          if (val.textContent !== txt) val.textContent = txt;
        }
      });
    } catch (e) {}
  }
  /*AVRIL*/ try { var fpMoT = 0; var fpMo = new MutationObserver(function () { if (fpMoT) return; var pi = document.querySelector('.product-information'); if (!pi) return; var need = [].some.call(pi.querySelectorAll('variant-picker fieldset.variant-option'), function (f) { var l = f.querySelectorAll('label.variant-option__button-label'); if (!l.length || f.querySelector('.variant-option__button-label--has-swatch')) return false; if (f.classList.contains('fp-swatchified')) return !f.querySelector('legend .variant-option__swatch-value') || !l[0].classList.contains('fp-sw'); return !f.dataset.fpSwSkip; }); if (!need) return; fpMoT = 1; try { swatchifyColors(); sortSizeOptions(); [].forEach.call(pi.querySelectorAll('variant-picker fieldset.variant-option:not(.fp-swatchified)'), function (f) { f.dataset.fpSwSkip = '1'; }); } finally { fpMoT = 0; } }); fpMo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (eMo) {}
  // Horizon re-renders the picker on every variant change: re-apply (cheap, idempotent).
  document.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('variant-picker')) { setTimeout(swatchifyColors, 60); setTimeout(swatchifyColors, 600); setTimeout(swatchifyColors, 1500); } });

  // 2026-09-18 buy box v2. (1) Rating reads "4.6 · 32 reviews" instead of "( 32 )". The Air Reviews widget
  // loads late, so this is retried a few times; it only rewrites the count node, never the widget itself.
  // (2) "Save 29%" pill next to a sale price, recomputed whenever Horizon re-renders the price.
  function enhanceRating() {
    try {
      var w = document.querySelector('.product-details .AirReviews-Widget--AppBlockSummary');
      if (!w || w.querySelector('.fp-rating-num')) return !!w;
      var star = w.querySelector('[aria-label]');
      var num = star && ((star.getAttribute('aria-label') || '').match(/[\d.,]+/) || [])[0];
      var cnt = Array.prototype.filter.call(w.querySelectorAll('*'), function (e) { return !e.children.length && /^\(?\s*\d+\s*\)?$/.test((e.textContent || '').trim()); })[0];
      if (!cnt) return false;
      var n = cnt.textContent.replace(/\D/g, '');
      var host = cnt;
      while (host.parentNode && host.parentNode !== w && !/\(/.test(host.textContent)) host = host.parentNode;
      host.textContent = '';
      if (num) { var sp = document.createElement('span'); sp.className = 'fp-rating-num notranslate'; sp.setAttribute('translate', 'no'); sp.textContent = num.replace(',', '.') + ' ·'; host.appendChild(sp); }
      host.appendChild(document.createTextNode(' ' + n + ' reviews'));
      return true;
    } catch (e) { return true; }
  }
  function fpMoneyToNumber(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d.,]/g, '');
    if (/,\d{1,2}$/.test(t)) t = t.replace(/\./g, '').replace(',', '.'); else t = t.replace(/,/g, '');
    return parseFloat(t) || 0;
  }
  function enhanceSavePill() {
    try {
      var pp = document.querySelector('.product-details product-price'); if (!pp) return;
      var sale = pp.querySelector('.price__sale:not(.price__hidden)');
      var old = pp.querySelector('.fp-save-pill');
      var now = sale ? fpMoneyToNumber(sale.querySelector('.price-item--sale')) : 0;
      var was = sale ? fpMoneyToNumber(sale.querySelector('.compare-at-price')) : 0;
      if (!(now && was > now)) { if (old) old.remove(); return; }
      var pct = Math.round(100 * (1 - now / was));
      if (old && old.getAttribute('data-pct') === String(pct) && old.parentNode === sale) return;
      if (old) old.remove();
      var pill = document.createElement('span');
      pill.className = 'fp-save-pill'; pill.setAttribute('data-pct', String(pct));
      pill.textContent = pct + '% off';   // one text node on purpose: the auto-translate widget turns a lone "Save" into "Sauvegarder"
      sale.appendChild(pill);
    } catch (e) {}
  }
  function enhanceBuyBox() {
    enhanceSavePill();
    var tries = 0;
    (function again(){ if (enhanceRating() || ++tries > 12) return; setTimeout(again, 700); })();
  }
  document.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('variant-picker')) { [80, 500, 1200, 2200].forEach(function(ms){ setTimeout(enhanceSavePill, ms); }); } });

  // 2026-09-18 (Mathéo): size options must read in ascending order (12 oz, 20.5 oz, 34 oz). The real order lives in
  // the Shopify product data; this only re-orders the DISPLAY with CSS `order`, and only when EVERY value of the
  // option parses as a size (number + optional unit). Colours, plugs and named styles are left untouched.
  function fpSizeValue(v) {
    var t = String(v || '').toLowerCase().replace(/,/g, '.').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(\d+(?:\.\d+)?)\s*(ml|cl|l|litre|liter|litres|liters|oz|fl oz|g|kg|cm|mm|in|inch|inches|"|''|cups?|tasses?|pcs?|pieces?|pi[eè]ces?|holes?|trous?|pack|x)?\b/);
    if (!m) return null;
    var n = parseFloat(m[1]), u = m[2] || '';
    if (u === 'l' || u === 'litre' || u === 'liter' || u === 'litres' || u === 'liters') n *= 1000;
    else if (u === 'cl') n *= 10;
    else if (u === 'oz' || u === 'fl oz') n *= 29.57;
    else if (u === 'kg') n *= 1000;
    else if (u === 'cm') n *= 10;
    return isNaN(n) ? null : n;
  }
  function sortSizeOptions() {
    try {
      document.querySelectorAll('.product-information variant-picker fieldset.variant-option').forEach(function(fs){
        var labels = Array.prototype.slice.call(fs.querySelectorAll('label.variant-option__button-label'));
        if (labels.length < 2) return;
        var vals = [];
        for (var i = 0; i < labels.length; i++) {
          var inp = labels[i].querySelector('input');
          var n = fpSizeValue(inp && inp.value);
          if (n === null) return;                 // not a size option
          vals.push(n);
        }
        var sorted = vals.slice().sort(function(a, b){ return a - b; });
        labels.forEach(function(l, i){ l.style.order = String(1 + sorted.indexOf(vals[i])); });
        var lg = fs.querySelector('legend'); if (lg) lg.style.order = '0';
        fs.classList.add('fp-size-sorted');
      });
    } catch (e) {}
  }
  document.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('variant-picker')) { [60, 600, 1500].forEach(function(ms){ setTimeout(sortSizeOptions, ms); }); } });

  function inject() {
    if (fpInjectLock) return;
    fpInjectLock = true;
    try { return _doInject(); } finally { setTimeout(function(){ fpInjectLock = false; }, 250); }
  }
  function _doInject() {
    var pi = document.querySelector('.product-information');
    if (!pi) return;

    // Find h1 (the actual product title  first H1 in product-details column)
    var details = pi.querySelector('.product-details, .product-info-section') || pi;
    var titleH1 = details.querySelector('h1');

    // Cleanup prior injections (do NOT remove [data-fp-pdp-stars] — Air Reviews
    // may have populated it; recreating would cause a flash and triggers Air Reviews
    // to re-render, which can cascade into Horizon section redraws and scroll jumps)
    pi.querySelectorAll('[data-fp-pdp-bc],[data-fp-pdp-eyebrow],[data-fp-pdp-subtitle],[data-fp-pdp-klarna],[data-fp-pdp-trust],[data-fp-pdp-specs],[data-fp-pdp-accordion],[data-fp-pdp-clook],[data-fp-pdp-clook-placeholder],[data-fp-pdp-promise],[data-fp-pdp-stars],[data-fp-pdp-highlights],[data-fp-pdp-delivery],[data-fp-pdp-compare],[data-fp-pdp-eta]').forEach(function(e){ e.remove(); });

    // Eyebrow (collection name above the title) removed: it was redundant with the title +
    // specs subtitle, only showed on desktop (hidden on mobile), and looked cluttered. Mobile
    // already reads cleaner without it, so we align desktop to that. buildEyebrow() kept unused.
    // Note: Air Reviews app embed handles the star rating itself — no manual injection.

    // (Klarna moved under ATC button  see Trust block below)

    // Inject after ATC  order matters: insertAdjacentHTML('afterend') stacks LIFO, so insert in reverse
    var atc = details.querySelector('button[name="add"], add-to-cart-component');
    var atcWrap = atc && (atc.closest('.product-form, .product-form__buttons') || atc.parentElement);
    if (atcWrap) {
      // We want order: ATC, trust, specs, accordion
      // afterend pushes; reverse insertion order → final DOM = trust, specs, accordion
      // Order in DOM (afterend stacks LIFO): klarna, trust, [complete-look async], promise, specs, accordion
      // 05/10/26 (fp-express-checkout-2026-10-05) : les boutons de paiement express restent collés sous « Add to cart » ; nos blocs passent dessous
      var fpAnchor = atcWrap; try { var fpNx = atcWrap.nextElementSibling; if (fpNx && fpNx.classList.contains('accelerated-checkout-block')) fpAnchor = fpNx; } catch (eA) {}
      fpAnchor.insertAdjacentHTML('afterend', buildAccordion());
      fpAnchor.insertAdjacentHTML('afterend', '<div data-fp-pdp-clook-placeholder></div>');
      fpAnchor.insertAdjacentHTML('afterend', buildTrust());
      fpAnchor.insertAdjacentHTML('afterend', buildDelivery());
      fpAnchor.insertAdjacentHTML('afterend', buildKlarna());
      try { var fpAv = details.querySelector('[data-fp-avril-under]'), fpEta = details.querySelector('[data-fp-pdp-eta]'); if (fpAv && fpEta) fpEta.insertAdjacentElement('afterend', fpAv); } catch (eAv) {} /*AVRIL : Klarna, livraison, puis Complete your ritual */

      // Move the native product description up: render it right after the trust strip
      // (above bundle/accordion). Final order: ATC, klarna, trust(+countdown), description, bundle, accordion.
      try {
        var trustEl = details.querySelector('[data-fp-pdp-trust]');
        var descEl = details.querySelector('[class*="text_aEtTtq"]') || details.querySelector('rte-formatter');
        if (trustEl && descEl) trustEl.insertAdjacentElement('afterend', descEl);
        if (trustEl) { var hl = buildHighlights(details); if (hl) trustEl.insertAdjacentHTML('afterend', hl); }
        swatchifyColors();
        sortSizeOptions();
        enhanceBuyBox();
        tidyDescription(details);
        buildStoryBand(pi, details);
      } catch(e){}

      // The specs subtitle is now rendered natively by the theme from the
      // custom.subtitle metafield (block subtitle_fp under the title). The old JS DOM-surgery
      // that extracted/stripped the line from the description has been removed — the line no
      // longer lives in the description body_html at all, so there is nothing to promote here.

      // Async: replace placeholder with complete-look
      buildCompleteLook().then(function(html) {
        var ph = document.querySelector('[data-fp-pdp-clook-placeholder]');
        if (ph && html) ph.outerHTML = html;
        else if (ph) ph.remove();
        // tous les blocs de vente groupée remontent juste sous la réassurance (sous le bouton d'achat, avant les points forts)
        try {
          var kitSec = document.querySelector('[data-fp-pdp-clook]');
          var trustK = document.querySelector('[data-fp-pdp-trust]');
          if (kitSec && kitSec.querySelector('.fp-pdp-kit') && trustK && trustK.parentNode) { trustK.insertAdjacentElement('afterend', kitSec); kitSec.classList.add('fp-pdp-clook--kit'); }
        } catch (eP) {}
        // Belt-and-suspenders dedup: keep only the first instance of each fp marker
        ['[data-fp-pdp-eyebrow]','[data-fp-pdp-klarna]','[data-fp-pdp-eta]','[data-fp-pdp-trust]','[data-fp-pdp-clook]','[data-fp-pdp-promise]','[data-fp-pdp-specs]','[data-fp-pdp-accordion]'].forEach(function(sel){
          var els = document.querySelectorAll(sel);
          els.forEach(function(el, i){ if (i > 0) el.remove(); });
        });
      }); // klarna immediately under ATC
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function() {
    if (!document.querySelector('.product-information')) return;

    setTimeout(inject, 100);
    setTimeout(inject, 600);

    // Bulletproof auto-heal  Horizon replaces .product-details on variant change,
    // wiping our injections. Check every 300ms and re-inject if missing.
    var lastPriceText = '';
    setInterval(function() {
      var pi = document.querySelector('.product-information');
      if (!pi) return;
      var details = pi.querySelector('.product-details, .product-info-section');
      if (!details) return;

      var hasKlarna  = !!details.querySelector('[data-fp-pdp-klarna]');
      var hasTrust   = !!details.querySelector('[data-fp-pdp-trust]');
      var hasAcc     = !!details.querySelector('[data-fp-pdp-accordion]');

      // If ANY of our core injections is missing, full re-inject (debounced).
      // Only check markers we ACTUALLY inject now: klarna, trust, accordion.
      // NOTE: hasStars intentionally NOT checked — Air Reviews mutates that div
      // and we don't want to re-inject (and re-fetch upsell) every time it does.
      // NOTE: eyebrow + specs intentionally NOT checked — they are no longer injected. Checking
      // them kept the heal firing every ~1.5s, which wiped open accordions ("auto-close" bug).
      if (!hasKlarna || !hasTrust || !hasAcc) {
        var now = Date.now();
        if (now - (window.__fpLastInject || 0) < 1500) return;
        window.__fpLastInject = now;
        inject();
        return;
      }

      // All present  sync klarna price if changed
      var pe = pi.querySelector('.price__regular');
      var cur = pe ? pe.textContent.trim() : '';
      if (cur && cur !== lastPriceText) {
        lastPriceText = cur;
        var oldK = details.querySelector('[data-fp-pdp-klarna]');
        if (oldK) oldK.outerHTML = buildKlarna();
      }
    }, 300);

    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest('.product-information .variant-picker input')) {
        setTimeout(inject, 150);
        setTimeout(inject, 500);
      }
    });

    document.addEventListener('variant:change', function() { setTimeout(inject, 100); });
    document.addEventListener('on:variant:change', function() { setTimeout(inject, 100); });
  });


  // Klarna modal
  function ensureKlarnaModal() {
    if (document.getElementById('fp-klarna-modal')) return;
    var html = '<div class="fp-klarna-modal" id="fp-klarna-modal" aria-hidden="true">'
      + '<div class="fp-klarna-modal__panel" role="dialog" aria-labelledby="fp-klarna-title">'
      + '<button class="fp-klarna-modal__close" data-fp-klarna-close aria-label="Close">×</button>'
      + '<span class="fp-klarna-modal__brand notranslate" translate="no">Klarna.</span>'
      + '<h3 id="fp-klarna-title">Pay in 4 interest-free instalments</h3>'
      + '<p>Split your purchase into 4 equal payments. No interest, no fees when you pay on time.</p>'
      + '<ul>'
      + '<li>1st payment today at checkout</li>'
      + '<li>3 remaining every 2 weeks, automatic</li>'
      + '<li>Quick approval, no impact on your credit score</li>'
      + '</ul>'
      + '<p style="font-size:0.75rem;color:#A55A33;">Subject to eligibility. Available at checkout. See Klarna terms.</p>'
      + '</div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
  }
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-fp-klarna-trigger]');
    if (trigger) {
      e.preventDefault();
      ensureKlarnaModal();
      var m = document.getElementById('fp-klarna-modal');
      m.classList.add('is-open');
      m.setAttribute('aria-hidden', 'false');
      return;
    }
    var close = e.target.closest('[data-fp-klarna-close]');
    var modal = e.target.closest('.fp-klarna-modal');
    if (close || (modal && e.target === modal)) {
      var m = document.getElementById('fp-klarna-modal');
      if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      var m = document.getElementById('fp-klarna-modal');
      if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); }
    }
  });



  // Countdown ticker. Two reasons for the design below:
  // 1) Update the text node in place (nodeValue), not textContent: textContent replaces the
  //    child node = a childList mutation the auto-translate widget re-processes -> flicker.
  //    nodeValue is a characterData change only, so nothing re-renders.
  // 2) Tick 4x/second and only write when the string actually changes. A plain 1000ms
  //    interval drifts off the real second boundary (and the browser throttles it), so a
  //    second visibly "holds" then skips -> looks non-linear. Re-deriving from absolute time
  //    at 250ms keeps the display glued to the true clock = smooth, even seconds.
  //    Singleton guard so re-inits never stack multiple tickers.
  if (!window.__fpCountdownTicker) {
    var fpLastCountdown = '';
    window.__fpCountdownTicker = setInterval(function() {
      var t = fpCountdownText();
      if (t === fpLastCountdown) return;
      fpLastCountdown = t;
      document.querySelectorAll('[data-fp-pdp-countdown]').forEach(function(el) {
        if (el.firstChild && el.firstChild.nodeType === 3) el.firstChild.nodeValue = t;
        else el.textContent = t;
      });
    }, 250);
  }

  // Complete the look  Add click
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('.fp-pdp-clook__add');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    var prev = btn.textContent;
    btn.textContent = 'Adding...'; btn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ id: id, quantity: 1 }) });
      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(function() { btn.textContent = prev; btn.disabled = false; }, 1500);
    } catch(err) { btn.textContent = 'Error'; setTimeout(function(){ btn.textContent = prev; btn.disabled = false; }, 1500); }
  });


  // Brew Kit : modale prix fixe, taille / couleur préchoisies d'après la fiche
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fp-kit-open]');
    if (!b) return;
    e.preventDefault();
    var K = _fpKitData; if (!K) return;
    var box = b.closest('[data-fp-kit]'); var sel = fpKitSelection(K, box ? box.getAttribute('data-fp-kit-cur') : '');
    var comps = [K.press, K.grinder].map(function (p) { return { id: String(p.id), handle: p.handle, title: p.title, image: fpImg(p) }; });
    var P = fpKitPrices(K, sel.si, sel.ci);
    openBundleModal({ title: 'The Brew Kit', eyebrow: P ? 'Save ' + fpMoneyShort(P.save) + ' together' : 'Press + grinder', handles: [K.handles[0]], comps: comps, kit: K, preselect: [_fpOptVals(K.kit, 0)[sel.si], _fpOptVals(K.kit, 1)[sel.ci]],
      labels: { price: 'Kit price', add: 'Add the Brew Kit to bag', note: 'Free tracked shipping &middot; 30-day returns' } });
  });

  // Ouverture du popup bundle (sélection variantes sur place)
  document.addEventListener('click', function(e) {
    var open = e.target.closest('[data-fp-ritual-open]');
    if (!open) return;
    e.preventDefault();
    openRitualModal(open.getAttribute('data-fp-ritual-open'));
  });

  // Set dynamique : ouvre la MEME modale (choix variantes par produit) au lieu d'ajouter en direct.
  document.addEventListener('click', function(e) {
    var b = e.target.closest('[data-fp-set-open]');
    if (!b) return;
    e.preventDefault();
    var handles = (b.getAttribute('data-fp-set-open') || '').split(',').filter(Boolean);
    if (!handles.length) return;
    var sp = parseInt(b.getAttribute('data-fp-set-save'), 10) || 15;
    openBundleModal({ title: 'Build your set', eyebrow: 'Buy all three, save ' + sp + '%', savePct: sp, handles: handles, labels: { price: 'Set price', add: 'Add the set to bag' } });
  });

  // Complete-the-look arrow nav
  document.addEventListener('click', function(e) {
    var prev = e.target.closest('[data-fp-pdp-clook-prev]');
    var next = e.target.closest('[data-fp-pdp-clook-next]');
    if (!prev && !next) return;
    var track = document.querySelector('[data-fp-pdp-clook-track]');
    if (!track) return;
    var card = track.querySelector('.fp-pdp-clook__card');
    var step = card ? card.getBoundingClientRect().width + 12 : 200;
    track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  });


  /* ============================================================
   *  Sticky ATC bar (mobile only)
   *  Shows a fixed bottom bar with image+title+price+ATC
   *  when the original ATC button is scrolled out of view.
   * ============================================================ */
  function setupStickyATC() {
    if (document.getElementById('fp-sticky-atc')) return;
    var pi = document.querySelector('.product-information');
    if (!pi) return;
    var origAtc = pi.querySelector('button[name="add"], add-to-cart-component button, add-to-cart-component');
    if (!origAtc) return;
    var titleEl = pi.querySelector('h1');
    var priceEl = pi.querySelector('.price__regular .price-item--regular') || pi.querySelector('.price__regular .price-item') || pi.querySelector('.price__regular');
    var imgEl = document.querySelector('.product-media img, .product-media__image, .product-media-gallery img');
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
    var title = titleEl ? titleEl.textContent.trim() : '';
    var price = priceEl ? priceEl.textContent.trim() : '';
    var bar = document.createElement('div');
    bar.id = 'fp-sticky-atc';
    bar.className = 'fp-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = ''
      + '<div class="fp-sticky-atc__inner">'
      + (imgSrc ? '<img class="fp-sticky-atc__img" src="' + imgSrc + '" alt="" loading="lazy" width="48" height="48">' : '')
      + '<div class="fp-sticky-atc__info">'
      +   '<div class="fp-sticky-atc__title">' + escapeHTML(title) + '</div>'
      +   '<div class="fp-sticky-atc__price">' + escapeHTML(price) + '</div>'
      + '</div>'
      + '<button type="button" class="fp-sticky-atc__btn" data-fp-sticky-atc-trigger>'
      +   '<span class="fp-sticky-atc__label">Add to cart</span>'
      +   '<span class="fp-sticky-atc__added" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><circle class="fp-atc-ring" cx="12" cy="12" r="9" stroke="#fff" stroke-width="1.7"/><path class="fp-atc-tick" d="M8 12.4l2.6 2.6L16.3 9" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
      + '</button>'
      + '</div>';
    document.body.appendChild(bar);

    // Forward click to original ATC
    bar.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-fp-sticky-atc-trigger]');
      if (!btn) return;
      var realAtc = pi.querySelector('button[name="add"]');
      if (!realAtc || realAtc.disabled) return;
      realAtc.click();
      btn.classList.add('fp-sticky-atc__btn--added');
      setTimeout(function(){ btn.classList.remove('fp-sticky-atc__btn--added'); }, 1600);
    });

    // Observe original ATC visibility — show sticky bar only when out of view
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) bar.classList.remove('is-visible');
          else bar.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      io.observe(origAtc);
    }

    // Sync price when variant changes (poll DOM, lightweight)
    var lastPrice = price;
    setInterval(function() {
      var p = pi.querySelector('.price__regular .price-item--regular') || pi.querySelector('.price__regular .price-item') || pi.querySelector('.price__regular');
      if (!p) return;
      var t = p.textContent.trim();
      if (t && t !== lastPrice) {
        lastPrice = t;
        var el = bar.querySelector('.fp-sticky-atc__price');
        if (el) el.textContent = t;
      }
    }, 500);
  }


  /* ============================================================
   *  Image zoom lightbox
   *  Click on a product gallery image -> fullscreen overlay
   *  with the high-res version. Click anywhere or Esc to close.
   * ============================================================ */
  function ensureLightbox() {
    if (document.getElementById('fp-lightbox')) return document.getElementById('fp-lightbox');
    var lb = document.createElement('div');
    lb.id = 'fp-lightbox';
    lb.className = 'fp-lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML = ''
      + '<button type="button" class="fp-lightbox__close" data-fp-lb-close aria-label="Close">×</button>'
      + '<img class="fp-lightbox__img" alt="" />';
    document.body.appendChild(lb);
    lb.addEventListener('click', function(e) {
      // Click outside the image OR on the close btn closes the lightbox
      if (e.target.closest('[data-fp-lb-close]') || e.target === lb) {
        closeLightbox();
      }
    });
    return lb;
  }
  function openLightbox(src, alt) {
    var lb = ensureLightbox();
    var img = lb.querySelector('.fp-lightbox__img');
    img.src = src;
    img.alt = alt || '';
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fp-no-scroll');
  }
  function closeLightbox() {
    var lb = document.getElementById('fp-lightbox');
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fp-no-scroll');
  }
  // Disable Horizon's image zoom WITHOUT breaking click delegation:
  // 1) Remove the `on:click="#zoom-dialog-.../open/0"` attribute from gallery slides
  //    → click no longer tries to open a dialog → no error → thumbs/buttons keep working
  // 2) Remove the `--zoomable` class → cursor reverts to default (no magnifier)
  // 3) Nuke the dialog element itself as a safety belt
  function _disableZoom() {
    document.querySelectorAll('.product-information slideshow-slide, .product-information .product-media-container').forEach(function(el) {
      el.removeAttribute('on:click');
      el.classList.remove('product-media-container--zoomable');
    });
    document.querySelectorAll('dialog.dialog-zoomed-gallery__dialog').forEach(function(d) {
      try { if (d.open) d.close(); } catch(e){}
      // 27/09/26 : retirer aussi le <zoom-dialog> parent, sinon Horizon leve "Required ref dialog not found" a son initialisation
      var z = d.closest('zoom-dialog');
      (z || d).remove();
    });
  }
  ready(function() {
    _disableZoom();
    // Re-apply if Horizon re-renders the gallery (variant change, ajax)
    var bodyMo = new MutationObserver(function(muts) {
      var shouldRerun = false;
      for (var i = 0; i < muts.length && !shouldRerun; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && (n.matches('slideshow-slide') || n.matches('dialog.dialog-zoomed-gallery__dialog'))) ||
              (n.querySelector && (n.querySelector('slideshow-slide') || n.querySelector('dialog.dialog-zoomed-gallery__dialog')))) {
            shouldRerun = true; break;
          }
        }
      }
      if (shouldRerun) _disableZoom();
    });
    bodyMo.observe(document.body, { childList: true, subtree: true });
  });

  // Init sticky ATC after main inject (delayed so DOM is ready)
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function() {
    setTimeout(setupStickyATC, 800);
    setTimeout(setupStickyATC, 2000);
  });

  // Sticky ATC bar toggle — show only when the main ATC button is OUT of viewport
  function setupNativeStickyATCToggle() {
    var sticky = document.querySelector('sticky-add-to-cart');
    var mainBtn = document.querySelector('.product-information button[name="add"], .product-information add-to-cart-component button, .product-information .add-to-cart-button');
    if (!sticky || !mainBtn) { setTimeout(setupNativeStickyATCToggle, 400); return; }
    if (sticky.dataset.fpToggleInit) return;
    sticky.dataset.fpToggleInit = '1';

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('fp-sticky-atc--visible');
        } else {
          sticky.classList.add('fp-sticky-atc--visible');
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    io.observe(mainBtn);
  }
  ready(function() {
    setupNativeStickyATCToggle();
    // Re-init on variant change (DOM may swap)
    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest('.product-information variant-picker')) {
        setTimeout(setupNativeStickyATCToggle, 200);
      }
    });
  });

})();
/* fp-cache-bump 2026-06-14b (force fp-bundles.json refresh after Morning-Ritual exclusion) */

/* 13/10/26 (Mathéo) : fiches produit, un seul menu dépliant ouvert à la fois (les autres se referment), sans saut de page. */
(function () {
  if (window.__amOneOpen || !/\/products\//.test(location.pathname)) return;
  window.__amOneOpen = 1;
  var SKIP = 'header, nav, dialog, [class*="drawer"], [class*="facet"], [class*="menu"]';
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.closest('main') || d.closest(SKIP)) return;
    var s = d.querySelector('summary'), y0 = s ? s.getBoundingClientRect().top : 0;
    document.querySelectorAll('main details[open]').forEach(function (o) {
      if (o !== d && !o.contains(d) && !d.contains(o) && !o.closest(SKIP)) o.open = false;
    });
    if (s) { var keep = function () { var dy = s.getBoundingClientRect().top - y0; if (Math.abs(dy) > 1) window.scrollTo({ top: window.scrollY + dy, behavior: 'instant' }); }; /* défilement doux du thème neutralisé ; le thème anime la fermeture : on recale pendant ~0,5 s */
      keep(); var t0 = Date.now(); (function loop() { keep(); if (Date.now() - t0 < 600) requestAnimationFrame(loop); })(); }
  }, true);
})();
